<template>
  <div class="mybooking-online">
    <div>
      <b-card>
        <vue-perfect-scrollbar
          :settings="{
            maxScrollbarLength: 150,
            suppressScrollX: true,
          }"
          style="height: 55vh"
          class="scrollable-container scroll-area"
        >
          <validation-observer
            class="pb-5"
            ref="quotationRules"
            v-if="request_quotation != null || serviceType != null"
          >
            <div
              v-if="
                (request_quotation
                  ? !['4', '5', '6'].includes(request_quotation.service_type)
                  : serviceType == null || !serviceType.service_type
                  ? false
                  : !['4', '5', '6'].includes(serviceType.service_type)) &&
                (step == 'quotation' || step == 'view-created-quotation')
              "
            >
              <b-row>
                <b-col
                  cols="12"
                  lg="4"
                  v-if="
                    request_quotation
                      ? status == 9 || status == 11
                        ? true
                        : false
                      : false
                  "
                >
                  <b-form-group>
                    <label>Incurred cost</label>

                    <b-form-input
                      :disabled="true"
                      v-model="quotation.incurredCost"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  :cols="
                    request_quotation
                      ? status == 9 || status == 11
                        ? 4
                        : 6
                      : 6
                  "
                >
                  <validation-provider
                    name="Carrier"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-group>
                      <label>Carrier<font class="red">*</font></label>

                      <Select4
                        v-model="quotation.shipping_line"
                        :class="[
                          errors.length > 0 ? 'is-invalid' : null,
                          readonly == true ? 'remove' : '',
                        ]"
                        placeholder="Carrier"
                        :disabled="readonly"
                        :options="{
                          value: 'id',
                          label: 'text',
                          data: shipping_lines,
                          fields: [
                            {
                              field: 'code',
                              label: 'Code',
                            },
                            {
                              field: 'name',
                              label: 'Shipping Line',
                            },
                          ],
                        }"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col
                  :cols="
                    request_quotation
                      ? status == 9 || status == 11
                        ? 4
                        : 6
                      : 6
                  "
                >
                  <validation-provider
                    name="FREQ"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-group>
                      <label>FREQ<font class="red">*</font></label>
                      <b-form-input
                        :state="errors.length > 0 ? false : null"
                        :disabled="readonly"
                        v-model="quotation.fred"
                        placeholder="FREQ"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>
              <b-row class="pb-1">
                <b-col cols="12" lg="4">
                  <validation-provider
                    name="Cut Off"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-group>
                      <label>Cut-off <font class="red">*</font></label>
                      <b-form-input
                        :state="errors.length > 0 ? false : null"
                        :disabled="readonly"
                        v-model="quotation.cut_off"
                        placeholder="Cut Off"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                    <!-- <b-form-group>
                      <label>Cut-off<font class="red">*</font> </label>

                       <date-picker  ref="datePicker"
                        v-model="quotation.cut_off"
                        type="datetime"
                        :disabled="readonly"
                        class="w-full"
                        value-type="format"
                        :state="errors.length > 0 ? false : null"
                        :class="errors.length ? 'mx-error' : ''"
                        title-format="DD-MM-YYYY"
                        time-title-format="DD-MM-YYYY"
                        placeholder="Select Datetime"
                        :show-time-panel="showTimePanel"
                        format="DD-MM-YYYY HH:mm"
                        @close="handleOpenChange"
                      >
                        <template v-slot:footer>
                          <button
                            class="mx-btn mx-btn-text"
                            @click="toggleTimePanel"
                          >
                            {{ showTimePanel ? "Date" : "Time" }}
                          </button>
                        </template>
                      </date-picker>
                      <small v-show="errors.length > 0" class="text-danger">{{
                        errors[0]
                      }}</small>
                    </b-form-group> -->
                  </validation-provider>
                </b-col>
                <b-col cols="12" lg="4">
                  <validation-provider
                    name="Transit Time"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-group>
                      <label>Transit Time<font class="red">*</font></label>
                      <b-form-input
                        :state="errors.length > 0 ? false : null"
                        :disabled="readonly"
                        v-model="quotation.transit_time"
                        placeholder="Transit Time"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="12" lg="4">
                  <validation-provider
                    name="Via"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-group>
                      <label>Via<font class="red">*</font></label>
                      <b-form-input
                        :state="errors.length > 0 ? false : null"
                        :disabled="readonly"
                        v-model="quotation.via"
                        placeholder="Via"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>
            </div>
            <!-- {{ quotation.valid_from }}
            {{ quotation }}
            {{ quotation.valid_to }} -->

            <!-- {{ JSON.parse(booking).valid_to }} -->
            <div
              class="custom_show_info_quotation"
              v-if="request_quotation.quotation || quotation.id"
            >
              <div class="quotation_info">
                <div class="mr-2">Quotation No.</div>
                <div class="">|</div>
                <div class="ml-2">
                  {{
                    request_quotation.quotation
                      ? request_quotation.quotation.toString().startsWith("WR1")
                        ? request_quotation.quotation
                        : ""
                      : ""
                  }}
                </div>
              </div>
              <div>
                <div class="validity_text">Validity period</div>
                <div class="custom_view_date">
                  <span class="text_date">Form</span>
                  <date-picker
                    :key="reloadDate + '123'"
                    :disabled="true"
                    v-model="valueDateFrom"
                    ref="datePicker"
                    type="date"
                    title-format="DD/MM/YYYY"
                    time-title-format="DD/MM/YYYY"
                    placeholder="Select date"
                    format="DD/MM/YYYY"
                    class="w-full"
                    value-type="format"
                  >
                  </date-picker>
                  <span class="text_date">To</span>
                  <date-picker
                    :key="reloadDate"
                    :disabled="true"
                    v-model="valueDateTo"
                    ref="datePicker"
                    type="date"
                    title-format="DD/MM/YYYY"
                    time-title-format="DD/MM/YYYY"
                    placeholder="Select date"
                    format="DD/MM/YYYY"
                    class="w-full"
                    value-type="format"
                  >
                  </date-picker>
                </div>
              </div>
            </div>
            <div
              class="border-lg py-1 rounded my-1 custom_inside_quote"
              v-for="(c, idx) in orderedCosts"
              :key="c.id"
            >
              <b-row class="custom_row_quote">
                <b-col cols="12">
                  <div class="float-left" style="margin-top: -3px !important">
                    <!-- <b-button
                      :disabled="
                        readonly ||
                        (booking &&
                          (booking.status_id == 8 || booking.status_id == 9))
                      "
                      @click="
                        () => {
                          costs.splice(idx, 1);
                        }
                      "
                      variant="flat-danger"
                      class="mr-1 p-0 m-0"
                    >
                      <feather-icon icon="MinusCircleIcon" />
                    </b-button> -->
                  </div>
                  <h5 class="float-left custom_name mr-1">
                    {{ Number(idx) + 1 }}. {{ c.name }}
                  </h5>
                  <div
                    :disabled="
                      readonly ||
                      (booking &&
                        (booking.status_id == 8 || booking.status_id == 9))
                    "
                    @click="
                      () => {
                        costs.splice(idx, 1);
                      }
                    "
                    class="cursor-pointer max-w-20"
                  >
                    <b-img width="15px" :src="remove" alt="logo" />
                  </div>
                  <!-- <div class="float-left" style="margin-top: -3px !important">
                    <b-button
                      :disabled="readonly"
                      @click="
                        () => {
                          var idRandom = Math.floor(
                            Math.random() * Math.pow(10, 15)
                          );
                          arrayNew.push(idRandom);
                          c.detail.push(
                            dataDefaultsAdd
                              ? {
                                  ...dataDefaultsAdd,
                                  id: idRandom,
                                  unit_price: 0,
                                  vat: 0,
                                }
                              : {
                                  id: idRandom,
                                  payableAcc: null,
                                  payableAcc_fast_id: '',
                                  payableAcc_tms_id: '',
                                  fee_type: 1,
                                  fee_type_name: 'Phí nâng cont',
                                  fee_type_dbt: '',
                                  fee_type_kbck: '',
                                  fee_type_freight: '',

                                  fee_type_logistics: '',
                                  fee_type_trucking: '',
                                  fee_type_code: '1',
                                  is_tms: '1',
                                  companyItems: 4,
                                  unit: 'CBM',
                                  unit_tms_id: '',
                                  unit_fast_id: 'CBM',
                                  unit_name: 'CBM CUBIC METRIC',
                                  unit_price: 0,
                                  qty: 1,
                                  currency: 'USD',
                                  notes: '',
                                  checked: true,
                                  vat: 0,
                                  payment: 'DEBT',
                                  tms_id: '',
                                  fast_id: '',
                                  fast_approve_id: '',
                                }
                          );
                        }
                      "
                      variant="flat-primary"
                      class="ml-1 p-0 m-0"
                    >
                      <feather-icon icon="PlusSquareIcon" />
                    </b-button>
                    
                  </div> -->
                </b-col>
              </b-row>
              <!-- <b-row>
                <b-col cols="3-1" class="pl-0"
                  ><span style="padding-left: 38px"
                    >Payable acc<font class="red"> *</font>
                  </span></b-col
                >
                <b-col cols="12" lg="2" class="pl-0"
                  ><span>Description<font class="red"> *</font></span></b-col
                >
                <b-col cols="1-1" class="pl-0"
                  >Unit <font class="red">*</font>
                </b-col>
                <b-col cols="12"  lg="1" class="pl-0"
                  >Unit Price <font class="red">*</font>
                </b-col>
                <b-col cols="12"  lg="1" class="pl-0"
                  >Quantity <font class="red">*</font>
                </b-col>
                <b-col cols="12"  lg="1" class="pl-0"
                  >Currency <font class="red">*</font>
                </b-col>
                <b-col cols="12"  lg="1" class="pl-0"
                  >VAT <font class="red">*</font>
                </b-col>
                <b-col cols="12"  lg="1" class="pl-0"
                  >Payment <font class="red">*</font>
                </b-col>
                <b-col cols="12"  lg="1" class="pl-0">Note</b-col>
              </b-row> -->
              <div class=" ">
                <b-row
                  v-for="(i, idx1) in c.detail"
                  :key="i.id + idx1"
                  class="custom-bg-quote"
                >
                  <b-col class="pl-0" cols="12" lg="2">
                    <!-- <div
                                            class="float-left"
                                            style="
                                                width: 33px;
                                                padding-top: 24px;
                                                padding-left: 0.6rem;
                                            "
                                        >
                                            <b-input-group>
                                                <b-form-checkbox
                                                    :disabled="
                                                        arrayNew.includes(i.id)
                                                            ? false
                                                            : readonly ||
                                                              readonlyEdit
                                                    "
                                                    v-model="i.checked"
                                                ></b-form-checkbox>
                                                <b-button
                                                    v-if="index > 0"
                                                    :disabled="
                                                        arrayNew.includes(i.id)
                                                            ? false
                                                            : readonly ||
                                                              readonlyEdit
                                                    "
                                                    @click="
                                                        c.detail.splice(
                                                            index,
                                                            1
                                                        )
                                                    "
                                                    variant="flat-danger"
                                                    class="p-0 m-0"
                                                >
                                                    <feather-icon
                                                        class="text-danger"
                                                        size="1.2x"
                                                        icon="DeleteIcon"
                                                    />
                                                </b-button>
                                            </b-input-group>
                                        </div> -->

                    <validation-provider
                      :name="'Payer' + ' ' + c.name + ' ' + Number(idx1) + 1"
                      #default="{ errors }"
                      rules="required"
                    >
                      <b-form-group>
                        <label class="custom_name_quote"
                          >Payer<font class="red"> *</font></label
                        >

                        <Select4
                          v-model="i.payableAcc"
                          :class="[
                            errors.length > 0 ? 'is-invalid' : null,
                            readonly == true ? 'remove' : '',
                          ]"
                          :disabled="
                            arrayNew.includes(i.id)
                              ? false
                              : readonly || readonlyEdit
                          "
                          placeholder="Payer"
                          @select="
                            ({ tms_id, fast_id }) => {
                              i.payableAcc_tms_id = tms_id;
                              i.payableAcc_fast_id = fast_id;
                            }
                          "
                          :options="{
                            isSearch: true,
                            width: '900px',
                            value: 'id',
                            label: 'text',
                            data: companyItemsName,
                            fields: [
                              {
                                field: 'code',
                                label: 'Tax Code',
                              },
                              {
                                field: 'text',
                                label: 'Company Name',
                              },
                              {
                                field: 'Acronym',
                                label: 'Acronym',
                                width: '300px',
                              },
                            ],
                          }"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col class="pl-0" cols="12" lg="2">
                    <!-- #default="{ errors }" -->
                    <!-- {{ i }} -->

                    <validation-provider
                      :name="
                        'Description' + ' ' + c.name + ' ' + Number(idx1) + 1
                      "
                      v-slot="{ errors }"
                      rules="required"
                    >
                      <b-form-group>
                        <label class="custom_name_quote"
                          >Description <font class="red"> *</font></label
                        >
                        <Select4
                          v-model="i.fee_type"
                          :class="[
                            errors.length > 0 ? 'is-invalid' : null,
                            readonly == true ? 'remove' : '',
                          ]"
                          :disabled="
                            arrayNew.includes(i.id)
                              ? false
                              : readonly || readonlyEdit
                          "
                          placeholder="Description"
                          @select="
                            ({
                              text,
                              is_tms,
                              dbt,
                              code,
                              logistics,
                              trucking,
                              tms_id,
                              kbck,
                              freight,
                              vat,
                              currency,
                            }) => {
                              i.fee_type_name = text;
                              i.vat = vat;
                              i.currency = currency;
                              i.fee_type_dbt = dbt;
                              i.fee_type_kbck = kbck;
                              i.fee_type_freight = freight;
                              i.fee_type_code = code;
                              i.fee_type_logistics = logistics;
                              i.fee_type_trucking = trucking;
                              i.is_tms = is_tms;
                              i.fee_type_tms_id = tms_id;
                            }
                          "
                          :options="{
                            isSearch: true,
                            width: '900px',
                            value: 'id',
                            label: 'text',
                            data: formatOptionCodeName(feeTypesFilter),
                            fields: [
                              {
                                field: 'code',
                                label: 'Code',
                              },
                              {
                                field: 'text',
                                label: 'Name',
                              },
                              {
                                field: 'description',
                                label: 'Description',
                                width: '300px',
                              },
                            ],
                          }"
                        />
                        <!-- <Select2
                        :class="[
                          errors.length > 0 ? 'is-invalid' : null,
                          readonly == true ? 'remove' : '',
                        ]"
                        :disabled="
                          arrayNew.includes(i.id)
                            ? false
                            : readonly || readonlyEdit
                        "
                        placeholder="Description"
                        @select="
                          ({
                            text,
                            is_tms,
                            dbt,
                            code,
                            logistics,
                            trucking,
                            tms_id,
                            kbck,
                            freight,
                            vat,
                            currency,
                          }) => {
                            i.fee_type_name = text;
                            i.vat = vat;
                            i.currency = currency;
                            i.fee_type_dbt = dbt;
                            i.fee_type_kbck = kbck;
                            i.fee_type_freight = freight;
                            i.fee_type_code = code;
                            i.fee_type_logistics = logistics;
                            i.fee_type_trucking = trucking;
                            i.is_tms = is_tms;
                            i.fee_type_tms_id = tms_id;
                          }
                        "
                        v-model="i.fee_type"
                        :options="formatOption(feeTypesFilter)"
                      /> -->
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col class="pl-0" cols="12" lg="1">
                    <validation-provider
                      :name="'Unit' + ' ' + c.name + ' ' + Number(idx1) + 1"
                      #default="{ errors }"
                      rules="required"
                    >
                      <b-form-group>
                        <label class="custom_name_quote"
                          >Unit <font class="red">*</font></label
                        >
                        <Select2
                          class="w-s-200"
                          :class="[
                            errors.length > 0 ? 'is-invalid' : null,
                            readonly == true ? 'remove' : '',
                          ]"
                          :disabled="
                            arrayNew.includes(i.id)
                              ? false
                              : readonly || readonlyEdit
                          "
                          placeholder="Unit "
                          v-model="i.unit"
                          @select="
                            ({ text, tms_id, fast_id }) => {
                              i.unit_name = text;
                              i.unit_tms_id = tms_id;

                              i.unit_fast_id = fast_id;
                            }
                          "
                          :options="unit_types"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col class="pl-0" cols="12" lg="1">
                    <validation-provider
                      name="Unit Price"
                      #default="{ errors }"
                      rules="required"
                    >
                      <b-form-group>
                        <label class="custom_name_quote"
                          >Unit Price <font class="red">*</font></label
                        >
                        <cleave
                          :disabled="readonly"
                          :options="$Utils.CONSTANTS.cleaveNumeral"
                          v-model="i.unit_price"
                          class="form-control"
                          placeholder="Unit Price"
                        />
                        <!-- <b-form-input type="text" @focus="$event.target.select()" @blur="
                          renderTotal++;
                        i.unit_price =
                          i.currency == 'VND'
                            ? FNVN(i.unit_price)
                            : FNUS(i.unit_price);
                        " :state="errors.length > 0 ? false : null" :disabled="readonly" v-model="i.unit_price" /> -->
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col class="pl-0" cols="12" lg="1">
                    <validation-provider
                      name="Quantity"
                      #default="{ errors }"
                      rules="required|minNumber:0"
                    >
                      <b-form-group>
                        <label class="custom_name_quote"
                          >Quantity<font class="red">*</font></label
                        >
                        <!-- <b-form-input
                          type="number"
                          @focus="$event.target.select()"
                          @blur="renderTotal++"
                          :state="errors.length > 0 ? false : null"
                          :disabled="readonly"
                          v-model="i.qty"
                        /> -->
                        <cleave
                          :disabled="readonly"
                          :options="$Utils.CONSTANTS.cleaveNumeral"
                          v-model="i.qty"
                          class="form-control"
                          placeholder="Unit Price"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col class="pl-0" cols="12" lg="1">
                    <validation-provider
                      name="Currency"
                      #default="{ errors }"
                      rules="required"
                    >
                      <b-form-group>
                        <label class="custom_name_quote"
                          >Currency<font class="red">*</font></label
                        >
                        <Select2
                          :class="[
                            errors.length > 0 ? 'is-invalid' : null,
                            readonly == true ? 'remove' : '',
                          ]"
                          :disabled="
                            arrayNew.includes(i.id)
                              ? false
                              : readonly || readonlyEdit
                          "
                          v-model="i.currency"
                          :options="currencies"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col class="pl-0" cols="12" lg="1">
                    <validation-provider
                      name="VAT"
                      #default="{ errors }"
                      rules="required|between:0,99"
                    >
                      <b-form-group>
                        <label class="custom_name_quote"
                          >VAT(%)<font class="red">*</font></label
                        >
                        <b-form-input
                          @focus="$event.target.select()"
                          type="number"
                          min="0"
                          max="5"
                          :state="errors.length > 0 ? false : null"
                          :disabled="readonly"
                          v-model="i.vat"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col class="pl-0" cols="12" lg="1">
                    <validation-provider #default="{ errors }" rules="required">
                      <b-form-group>
                        <label class="custom_name_quote"
                          >Amount<font class="red">*</font></label
                        >
                        <b-form-input
                          :state="errors.length > 0 ? false : null"
                          :disabled="true"
                          :value="
                            (
                              i.qty * i.unit_price +
                              (i.vat / 100) * i.qty * i.unit_price
                            ).toLocaleString()
                          "
                        />

                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <!-- v-model="value.stack_able" -->
                  <!-- @change="handleChange(1)" -->
                  <b-col cols="6" lg="2">
                    <b-row>
                      <div class="custom_check_quote">
                        <div class="flex items-center">
                          <input
                            :disabled="readonly"
                            type="radio"
                            class="custom-checkbox-new"
                            value="DEBT"
                            v-model="i.payment"
                            :checked="i.payment === 'DEBT'"
                          />

                          <div class="margin-left">Debit</div>
                        </div>

                        <div class="flex items-center">
                          <input
                            :disabled="readonly"
                            v-model="i.payment"
                            type="radio"
                            value="BEHALF"
                            class="custom-checkbox-new"
                            :checked="i.payment === 'BEHALF'"
                          />
                          <div class="margin-left">Credit</div>
                        </div>
                      </div>
                      <div class="custom_list_icon">
                        <div
                          class="cursor-pointer"
                          v-if="!readonly"
                          @click="
                            () => {
                              var idRandom = Math.floor(
                                Math.random() * Math.pow(10, 15)
                              );
                              arrayNew.push(idRandom);
                              c.detail.push(
                                dataDefaultsAdd
                                  ? {
                                      ...dataDefaultsAdd,
                                      id: idRandom,
                                      unit_price: 0,
                                      vat: 0,
                                      fee_type: null,
                                      fee_type_name: null,
                                      fee_type_dbt: 0,
                                      fee_type_kbck: 0,
                                      fee_type_freight: 0,
                                      fee_type_logistics: 0,
                                      fee_type_trucking: 0,
                                      fee_type_code: null,
                                    }
                                  : {
                                      id: idRandom,
                                      payableAcc: null,
                                      payableAcc_fast_id: '',
                                      payableAcc_tms_id: '',
                                      fee_type: 1,
                                      fee_type_name: '',
                                      fee_type_dbt: 0,
                                      fee_type_kbck: 0,
                                      fee_type_freight: 0,

                                      fee_type_logistics: 0,
                                      fee_type_trucking: 0,
                                      fee_type_code: '1',
                                      is_tms: '1',
                                      companyItems: 4,
                                      unit: 'CBM',
                                      unit_tms_id: null,
                                      unit_fast_id: 'CBM',
                                      unit_name: 'CBM CUBIC METRIC',
                                      unit_price: 0,
                                      qty: 1,
                                      currency: 'USD',
                                      notes: '',
                                      checked: true,
                                      vat: 0,
                                      payment: 'DEBT',
                                      tms_id: '',
                                      fast_id: '',
                                      fast_approve_id: '',
                                    }
                              );
                            }
                          "
                        >
                          <b-img width="30px" :src="iconAdd" alt="logo" />
                        </div>
                        <div
                          v-if="!readonly"
                          class="cursor-pointer"
                          @click="c.detail.splice(idx1, 1)"
                        >
                          <b-img width="30px" :src="remove" alt="logo" />
                        </div>
                      </div>
                    </b-row>
                    <small
                      class="text-danger custom-danger"
                      v-if="i.payment == ''"
                      >Please select at least one checkbox.</small
                    >
                  </b-col>
                  <b-col class="pl-0" cols="12" lg="2">
                    <validation-provider #default="{ errors }" rules="">
                      <b-form-group>
                        <label class="custom_name_quote">Note </label>

                        <b-form-textarea
                          :state="errors.length > 0 ? false : null"
                          :disabled="
                            arrayNew.includes(i.id)
                              ? false
                              : readonly || readonlyEdit
                          "
                          v-model="i.notes"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <!-- trunkId -->

                  <b-col
                    class="pl-0"
                    cols="12"
                    lg="2"
                    v-if="truckList.length > 0"
                  >
                    <validation-provider
                      :name="'trunkId' + ' ' + c.name + ' ' + Number(idx1) + 1"
                      #default="{ errors }"
                      :rules="
                        i.is_tms != 0
                          ? `required|divisibleByQuantity:${i.qty}`
                          : ``
                      "
                    >
                      <b-form-group>
                        <label class="custom_name_quote"
                          >Truck ID
                          <font v-if="i.is_tms != 0" class="red">*</font></label
                        >

                        <SelectCheckbox
                          v-model="i.truckId"
                          :disabled="
                            arrayNew.includes(i.id)
                              ? false
                              : readonly || readonlyEdit
                          "
                          :options="truckList"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
              </div>

              <!-- end -->
            </div>
            <div
              class="pt-1"
              v-if="
                costs !== null &&
                costs.length < default_costs.length &&
                !readonly
              "
            >
              <b-row>
                <b-col cols="12">
                  <div class="float-left">
                    <b-dropdown
                      variant="link"
                      toggle-class="text-decoration-none p-0 ml-1 text-primary"
                      no-caret
                    >
                      <template v-slot:button-content>
                        <h5 class="float-left">
                          <!-- <feather-icon
                            icon="PlusIcon"
                            class="text-primary align-middle"
                          /> -->
                          <b-img
                            class="mr-1"
                            width="30px"
                            :src="iconAdd"
                            alt="logo"
                          />
                          <span class="custom-font"> Add more </span>
                        </h5>
                        <!-- <feather-icon
                          icon="MoreVerticalIcon"
                          size="16"
                          class="text-primary align-middle mr-25"
                        /> -->
                      </template>
                      <b-dropdown-item
                        @click="
                          () => {
                            i.detail[0] = {
                              ...dataDefaultsAdd,
                              unit_price: 0,
                            } || {
                              id: idRandom,
                              payableAcc: null,
                              payableAcc_fast_id: '',
                              payableAcc_tms_id: '',
                              fee_type: 1,
                              fee_type_name: 'Phí nâng cont',
                              fee_type_dbt: 0,
                              fee_type_kbck: 0,
                              fee_type_freight: 0,
                              fee_type_logistics: 0,
                              fee_type_trucking: 0,
                              fee_type_code: '1',
                              is_tms: '1',
                              companyItems: 4,
                              unit: 'CBM',
                              unit_tms_id: null,
                              unit_fast_id: 'CBM',
                              unit_name: 'CBM CUBIC METRIC',
                              unit_price: 0,
                              qty: 1,
                              currency: 'USD',
                              notes: '',
                              checked: true,
                              vat: 0,
                              payment: 'DEBT',
                              tms_id: '',
                              fast_id: '',
                              fast_approve_id: '',
                              truckId: '',
                            };
                            costs.push(i);
                            arrayNew.push(i.detail[0].id);
                          }
                        "
                        :key="i.id"
                        v-for="i in default_costs.filter(
                          (i) => costs.filter((j) => j.id === i.id).length == 0
                        )"
                      >
                        <feather-icon icon="FolderIcon" class="mr-50" />
                        <span>{{ i.name }}</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </b-col>
              </b-row>
            </div>
            <b-row>
              <b-col cols="12" lg="8"></b-col>
              <b-col cols="12" lg="3">
                <b-card no-body class="mb-0 pt-1 px-1">
                  <b-row>
                    <b-col cols="12" lg="6">
                      <h3 class="text-custom_quote">Subtotal</h3>
                    </b-col>
                    <b-col cols="8" lg="6">
                      <b-row v-for="c in currencies" :key="c.id">
                        <b-col cols="12" v-if="getTotal(c.id) > 0">
                          <b-row class="justify-end">
                            <h3 class="mb-0 mr-1">
                              {{
                                c.id == "VND"
                                  ? $Utils.formatMooney(getTotal(c.id), "en-US")
                                  : $Utils.formatMooney(getTotal(c.id), "en-US")
                              }}
                            </h3>

                            <h3 class="mb-0">
                              {{ c.id }}
                            </h3>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
              <b-col lg="1"></b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="8"></b-col>
              <b-col cols="12" lg="3">
                <b-card no-body class="mb-0 px-1">
                  <b-row>
                    <b-col cols="12" lg="6">
                      <h3 class="text-custom_quote">VAT(%)</h3>
                    </b-col>
                    <b-col cols="8" lg="6">
                      <b-row v-for="c in currencies" :key="c.id">
                        <b-col cols="12" v-if="getTotal(c.id) > 0">
                          <b-row class="justify-end">
                            <h3 class="mb-0 mr-1">
                              {{
                                c.id == "VND"
                                  ? $Utils.formatMooney(
                                      getTotalVAT(c.id),
                                      "en-US"
                                    )
                                  : $Utils.formatMooney(
                                      getTotalVAT(c.id),
                                      "en-US"
                                    )
                              }}
                            </h3>

                            <h3 class="mb-0">
                              {{ c.id }}
                            </h3>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
              <b-col lg="1"></b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="8"></b-col>
              <b-col cols="12" lg="3">
                <b-card no-body class="mb-1 px-1">
                  <b-row>
                    <b-col cols="12" lg="6">
                      <h3 class="text-custom_quote">Grand Total</h3>
                    </b-col>
                    <b-col cols="8" :key="renderTotal" lg="6">
                      <b-row v-for="c in currencies" :key="c.id">
                        <b-col cols="12" v-if="getTotal(c.id) > 0">
                          <b-row class="justify-end">
                            <h3 class="mb-0 mr-1">
                              {{
                                c.id == "VND"
                                  ? $Utils.formatMooney(
                                      getTotalGrandTotal(c.id),
                                      "en-US"
                                    )
                                  : $Utils.formatMooney(
                                      getTotalGrandTotal(c.id),
                                      "en-US"
                                    )
                              }}
                            </h3>

                            <h3 class="mb-0">
                              {{ c.id }}
                            </h3>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
              <b-col lg="1"></b-col>
            </b-row>
            <div
              class="mb-3"
              v-if="
                (userData.userType == $Utils.CONSTANTS.USER_TYPE_O.Admin_Sale ||
                  userData.userType == $Utils.CONSTANTS.USER_TYPE_O.Admin) &&
                step == 'booking'
              "
            >
              <div v-for="(c, index) in commission" :key="index">
                <b-row>
                  <!-- <h5 class="float-left ml-2">{{ c.name }}</h5> -->
                  <b-row>
                    <b-col cols="12">
                      <h5 class="float-left custom_name ml-2">
                        {{ c.name }}
                      </h5>
                      <div
                        class="float-left"
                        style="margin-top: -3px !important"
                      >
                        <b-button
                          :disabled="readonly"
                          @click="
                            () => {
                              var idRandom = Math.floor(
                                Math.random() * Math.pow(10, 15)
                              );
                              c.detail.length == 0
                                ? c.detail.push({
                                    id: idRandom,
                                    payableAcc: null,
                                    payableAcc_fast_id: '',
                                    payableAcc_tms_id: '',
                                    fee_type: 234,
                                    fee_type_name: 'COMMISSION TO CUSTOMER',
                                    fee_type_dbt: 0,
                                    fee_type_kbck: 0,
                                    fee_type_freight: 0,
                                    fee_type_logistics: 0,
                                    fee_type_trucking: 0,
                                    fee_type_code: 'B_COMMISSIONCUSTOMER',
                                    is_tms: '0',
                                    companyItems: 4,
                                    unit: 'CBM',
                                    unit_tms_id: null,
                                    unit_fast_id: 'CBM',
                                    unit_name: 'CBM CUBIC METRIC',
                                    unit_price: 0,
                                    qty: 1,
                                    currency: 'USD',
                                    notes: '',
                                    checked: true,
                                    vat: 0,
                                    payment: 'DEBT',
                                    tms_id: '',
                                    fast_id: '',
                                    fast_approve_id: '',
                                  })
                                : c.detail.push({
                                    ...c.detail[0],
                                  });
                            }
                          "
                          variant="flat-primary"
                          class="ml-1 p-0 m-0"
                        >
                          <feather-icon icon="PlusSquareIcon" />
                        </b-button>
                        <!-- {{dataDefaultsAdd}} -->
                        <!-- {{ c.detail }} -->
                      </div>
                    </b-col>
                  </b-row>
                </b-row>

                <b-row
                  v-for="(i, index) in c.detail"
                  :key="index"
                  class="custom-bg-quote"
                >
                  <b-col lg="2" class="pl-0">
                    <!-- <div
                    >
                      <b-input-group>
                        <b-button
                          v-if="index > 0"
                          :disabled="
                            arrayNew.includes(i.id)
                              ? false
                              : readonly || readonlyEdit
                          "
                          @click="c.detail.splice(index, 1)"
                          variant="flat-danger"
                          class="p-0 m-0"
                        >
                          <feather-icon
                            class="text-danger"
                            size="1.2x"
                            icon="DeleteIcon"
                          />
                        </b-button>
                      </b-input-group>
                    </div> -->
                    <validation-provider
                      #default="{ errors }"
                      rules="required"
                      name="Payer"
                    >
                      <b-form-group>
                        <label class="custom_name_quote"
                          >Payer<font class="red"> *</font></label
                        >

                        <Select4
                          v-model="i.payableAcc"
                          :class="[
                            errors.length > 0 ? 'is-invalid' : null,
                            readonly == true ? 'remove' : '',
                          ]"
                          :disabled="readonly"
                          placeholder="Payer"
                          @select="
                            ({ tms_id, fast_id }) => {
                              i.payableAcc_tms_id = tms_id;
                              i.payableAcc_fast_id = fast_id;
                            }
                          "
                          :options="{
                            isSearch: true,
                            width: '900px',
                            value: 'id',
                            label: 'text',
                            data: companyItemsName,
                            fields: [
                              {
                                field: 'code',
                                label: 'Tax Code',
                              },
                              {
                                field: 'text',
                                label: 'Company Name',
                              },
                              {
                                field: 'Acronym',
                                label: 'Acronym',
                                width: '300px',
                              },
                            ],
                          }"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <b-col cols="12" lg="2" class="pl-0">
                    <validation-provider #default="{ errors }" rules="required">
                      <b-form-group>
                        <label class="custom_name_quote"
                          >Description<font class="red"> *</font></label
                        >
                        <Select2
                          :class="[
                            errors.length > 0 ? 'is-invalid' : null,
                            readonly == true ? 'remove' : '',
                          ]"
                          :disabled="true"
                          v-model="i.fee_type"
                          @select="
                            ({
                              tms_id,
                              text,
                              is_tms,
                              dbt,
                              code,
                              logistics,
                              trucking,
                              kbck,
                              freight,
                              currency,
                              vat,
                            }) => {
                              i.vat = vat;
                              i.currency = currency;
                              i.fee_type_name = text;
                              i.fee_type_dbt = dbt;
                              i.fee_type_kbck = kbck;
                              i.fee_type_freight = freight;
                              i.fee_type_code = code;
                              i.fee_type_logistics = logistics;
                              i.fee_type_trucking = trucking;

                              i.is_tms = is_tms;
                              i.fee_type_tms_id = tms_id;
                            }
                          "
                          :options="formatOptionCodeName(fee_types)"
                        />
                        <small class="text-danger" v-show="errors.length > 0">{{
                          errors[0]
                        }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col class="pl-0" lg="1">
                    <validation-provider #default="{ errors }" rules="required">
                      <b-form-group>
                        <label class="custom_name_quote"
                          >Unit<font class="red"> *</font></label
                        >
                        <Select2
                          :class="[
                            errors.length > 0 ? 'is-invalid' : null,
                            readonly == true ? 'remove' : '',
                          ]"
                          :disabled="readonly"
                          placeholder="POL"
                          v-model="i.unit"
                          @select="
                            ({ text }) => {
                              i.unit_name = text;
                            }
                          "
                          :options="unit_types"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col cols="12" lg="1" class="pl-0">
                    <validation-provider
                      name="Unit Price"
                      #default="{ errors }"
                      rules="required"
                    >
                      <b-form-group>
                        <label class="custom_name_quote"
                          >Unit Price<font class="red"> *</font></label
                        >
                        <cleave
                          :disabled="readonly"
                          :options="$Utils.CONSTANTS.cleaveNumeral"
                          v-model="i.unit_price"
                          class="form-control"
                          placeholder="Unit Price"
                        />
                        <!-- <b-form-input type="text" @blur="
                          i.unit_price =
                          i.currency == 'VND'
                            ? FNVN(i.unit_price)
                            : FNUS(i.unit_price)
                        " :state="errors.length > 0 ? false : null" :disabled="readonly" v-model="i.unit_price" /> -->
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col cols="12" lg="1" class="pl-0">
                    <validation-provider
                      name="Quantity"
                      #default="{ errors }"
                      rules="required"
                    >
                      <b-form-group>
                        <label class="custom_name_quote"
                          >Quantity<font class="red"> *</font></label
                        >

                        <!-- <b-form-input
                          type="number"
                          :state="errors.length > 0 ? false : null"
                          :disabled="readonly"
                          v-model="i.qty"
                        /> -->
                        <cleave
                          :disabled="readonly"
                          :options="$Utils.CONSTANTS.cleaveNumeral"
                          v-model="i.qty"
                          class="form-control"
                          placeholder="Unit Price"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col cols="12" lg="1" class="pl-0">
                    <validation-provider #default="{ errors }" rules="required">
                      <b-form-group>
                        <label class="custom_name_quote"
                          >Currency<font class="red"> *</font></label
                        >

                        <Select2
                          :class="[
                            errors.length > 0 ? 'is-invalid' : null,
                            readonly == true ? 'remove' : '',
                          ]"
                          :disabled="readonly"
                          v-model="i.currency"
                          :options="currencies"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col cols="12" lg="1" class="pl-0">
                    <validation-provider
                      name="VAT"
                      #default="{ errors }"
                      rules="required"
                    >
                      <b-form-group>
                        <label class="custom_name_quote"
                          >VAT(%)<font class="red"> *</font></label
                        >
                        <b-form-input
                          type="number"
                          min="0"
                          max="5"
                          :state="errors.length > 0 ? false : null"
                          :disabled="readonly"
                          v-model="i.vat"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col cols="12" lg="1" class="pl-0">
                    <validation-provider #default="{ errors }" rules="required">
                      <b-form-group>
                        <label class="custom_name_quote"
                          >Amount<font class="red">*</font></label
                        >
                        <b-form-input
                          :state="errors.length > 0 ? false : null"
                          :disabled="true"
                          :value="
                            (
                              i.qty * i.unit_price +
                              (i.vat / 100) * i.qty * i.unit_price
                            ).toLocaleString()
                          "
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col cols="6" lg="2">
                    <b-row>
                      <div class="custom_check_quote">
                        <div class="flex items-center">
                          <input
                            :disabled="readonly"
                            type="radio"
                            class="custom-checkbox-new"
                            value="DEBT"
                            v-model="i.payment"
                            :checked="i.payment === 'DEBT'"
                          />

                          <div class="margin-left">Debit</div>
                        </div>

                        <div class="flex items-center">
                          <input
                            :disabled="readonly"
                            v-model="i.payment"
                            type="radio"
                            value="BEHALF"
                            class="custom-checkbox-new"
                            :checked="i.payment === 'BEHALF'"
                          />
                          <div class="margin-left">Credit</div>
                        </div>
                      </div>
                      <div class="custom_list_icon">
                        <div
                          class="cursor-pointer"
                          v-if="!readonly"
                          @click="
                            () => {
                              var idRandom = Math.floor(
                                Math.random() * Math.pow(10, 15)
                              );
                              c.detail.push({
                                ...c.detail[0],
                              });
                            }
                          "
                        >
                          <b-img width="30px" :src="iconAdd" alt="logo" />
                        </div>
                        <div
                          v-if="!readonly"
                          class="cursor-pointer"
                          @click="c.detail.splice(index, 1)"
                        >
                          <b-img width="30px" :src="remove" alt="logo" />
                        </div>
                      </div>
                    </b-row>
                    <small
                      class="text-danger custom-danger"
                      v-if="i.payment == ''"
                      >Please select at least one checkbox.</small
                    >
                  </b-col>
                  <b-col cols="12" lg="2" class="pl-0">
                    <validation-provider #default="{ errors }" rules="">
                      <b-form-group>
                        <label class="custom_name_quote">Note</label>

                        <b-form-textarea
                          :state="errors.length > 0 ? false : null"
                          :disabled="readonly"
                          v-model="i.notes"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
              </div>
            </div>

            <div v-if="step !== 'booking'" class="border rounded py-1">
              <b-row>
                <b-col cols="12">
                  <h4 class="text-primary">Remark</h4>
                </b-col>
                <b-col cols="12" lg="6">
                  <validation-provider
                    name="Valid From"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-group>
                      <label>Valid From</label>
                      <b-form-datepicker
                        :state="errors.length > 0 ? false : null"
                        v-model="quotation.valid_from"
                        :disabled="readonly"
                        :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                        locale="vi-VN"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="12" lg="6">
                  <validation-provider
                    name="To"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-group>
                      <label>To<font class="red">*</font></label>
                      <b-form-datepicker
                        :state="errors.length > 0 ? false : null"
                        :disabled="readonly"
                        :min="quotation.valid_from"
                        v-model="quotation.valid_to"
                        :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                        locale="vi-VN"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="12">
                  <validation-provider
                    name="Notes"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-group>
                      <label>Notes<font class="red">*</font></label>
                      <b-form-textarea
                        :disabled="readonly"
                        rows="4"
                        v-model="quotation.quotationNotes"
                      >
                      </b-form-textarea>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>
            </div>
            <vue-html2pdf
              v-if="showPdf"
              :show-layout="false"
              :float-layout="true"
              :enable-download="false"
              :preview-modal="true"
              :paginate-elements-by-height="1300"
              :pdf-quality="2"
              :manual-pagination="false"
              pdf-format="a3"
              @progress="onProgress"
              pdf-orientation="portrait"
              pdf-content-width="100%"
              ref="html2Pdf"
              :html-to-pdf-options="{
                margin: 15,
                jsPDF: {
                  orientation: 'portrait',
                  format: 'a3',
                  unit: 'mm',
                },
              }"
            >
              <section slot="pdf-content">
                <print-quotation
                  v-if="request_quotation != null && step !== 'booking'"
                  :costs="costs"
                  :fee_types="fee_types"
                  :unit_types="unit_types"
                  :currencies="currencies"
                  :request_quotation="request_quotation"
                  :view_quotation="quotation"
                  :service_types="service_types"
                  :regions="regions"
                  :companyItems="companyItems"
                  :locations="locations"
                  :cont_types="cont_types"
                />
                <print-pricing
                  v-else
                  :costs="costs"
                  :fee_types="fee_types"
                  :unit_types="unit_types"
                  :currencies="currencies"
                  :request_quotation="request_quotation"
                  :view_quotation="quotation"
                  :service_types="service_types"
                  :companyItems="companyItems"
                  :locations="locations"
                />
              </section>
            </vue-html2pdf>
          </validation-observer>
        </vue-perfect-scrollbar>
      </b-card>
      <div v-if="request_quotation != null">
        <div class="custom_list_handle_quote">
          <a
            @click="
              () => {
                $bvModal.show('cancel-booking_1');
                cancel_reason = '';
              }
            "
            v-if="
              (request_quotation.accept_edit == 1 &&
                step == 'booking' &&
                !isCustomer &&
                status != 10) ||
              (isCustomer &&
                (status == 5 ||
                  status == 6 ||
                  status == 61 ||
                  status == 16 ||
                  status == 17))
            "
            class="btn btn-cancel-custom pl-2 pr-2 mr-1"
          >
            <!-- <feather-icon icon="DeleteIcon" />  -->
            Cancel
          </a>
          <!-- <a @click="handSaveDraft" v-if="request_quotation.accept_edit == 1 &&
            !isCustomer &&
            (!readonly && !showUpdate) &&
            (step == 'booking' || step == 'quotation') &&
            status != 5 && status != 10
            " class="btn custom_btn_quote pl-2 pr-2 mr-1">
            Save as Draft
          </a> -->
          <a
            v-if="
              costs !== null &&
              request_quotation.status_id != 6 &&
              request_quotation.status_id &&
              request_quotation.status_id != 5 &&
              status != 10
            "
            @click="generateReport"
            class="btn custom_btn_quote pl-2 pr-2 mr-1"
          >
            <!-- <feather-icon icon="SendIcon" /> -->
            {{ step == "booking" ? "Preview Debit Note" : "Preview quotation" }}
          </a>
          <!-- <b-progress :value="valueProgress" max="100" show-progress animated></b-progress> -->
          <!--step quotation-->

          <a
            @click="handSend"
            v-if="
              !readonly &&
              (status == 1 ||
                status == 21 ||
                status == 2 ||
                status == 3 ||
                request_quotation.status_id == 2 ||
                (status == 62 && step != 'booking') ||
                status == 4) &&
              create == false
            "
            class="btn btn-warning custom_btn_quote pl-2 pr-2 mr-1"
          >
            <!-- <feather-icon icon="SendIcon" /> -->
            Send a quotation
          </a>

          <!-- <button
            @click="handIsDraft"
            v-if="
              request_quotation.accept_edit == 1 &&
              !isCustomer &&
              !readonly &&
              ((step == 'booking' &&
                booking &&
                JSON.stringify(booking['tempQuotation']) !== '{}' &&
                booking['tempQuotation']) ||
                (step == 'quotation' &&
                  view_quotation &&
                  JSON.stringify(view_quotation) !== '{}' &&
                  view_quotation['tempQuotation']))
            "
            class="btn custom_btn_quote pl-2 pr-2 mr-1 float-right"
          >
            Draft
          </button> -->
          <button
            @click="$bvModal.show('request-an-update')"
            :disabled="isCustomer && status == 21"
            v-if="
              isCustomer &&
              status != 10 &&
              status !== 5 &&
              status !== 6 &&
              status !== 7 &&
              status !== 8 &&
              status !== 9 &&
              status !== 11 &&
              status !== 63 &&
              status !== 62 &&
              status !== 17 &&
              this.step !== 'view-quotation-booking'
            "
            class="btn custom_btn_quote pl-2 pr-2 mr-1"
          >
            <!-- <feather-icon icon="SendIcon" /> -->
            {{
              step == "view-created-quotation" ? "Bargain" : "Request an Update"
            }}
          </button>

          <a
            @click="acceptQuotation"
            v-if="
              isCustomer &&
              status != 10 &&
              status !== 5 &&
              status !== 61 &&
              status !== 6 &&
              status !== 7 &&
              status !== 8 &&
              status !== 9 &&
              status !== 11 &&
              status !== 63 &&
              step != 'booking'
            "
            class="btn custom_btn_quote pl-2 pr-2 mr-1"
          >
            <!-- <feather-icon icon="CheckSquareIcon" /> -->
            Booking
          </a>
          <!--step booking-->

          <a
            @click="$bvModal.show('accept-booking')"
            v-if="
              request_quotation.accept_edit == 1 &&
              status != 10 &&
              step == 'booking' &&
              !isCustomer &&
              status == 6
            "
            class="btn custom_btn_quote pl-2 pr-2 mr-1"
          >
            <!-- <feather-icon icon="UploadIcon" />  -->
            Upload booking
          </a>
          <a
            @click="handleUpdateCancel"
            v-if="showUpdate && status != 10"
            class="btn custom_btn_quote pl-2 pr-2 mr-1"
          >
            <!-- <feather-icon icon="UploadIcon" />  -->
            Update(Cancel)
          </a>
          <a
            @click="$bvModal.show('edit-booking')"
            v-if="
              !isCustomer &&
              step == 'booking' &&
              !copy &&
              request_quotation.status_id != 6 &&
              request_quotation.status_id != 5
            "
            class="btn custom_btn_quote pl-2 pr-2 mr-1"
          >
            <!-- <feather-icon icon="CheckSquareIcon" />  -->
            Update
          </a>
          <a
            class="btn custom_btn_quote pl-2 pr-2 mr-1"
            v-if="
              step == 'booking' &&
              status != 10 &&
              !isCustomer &&
              request_quotation.status_id != 6 &&
              request_quotation.status_id != 5
            "
            @click="showModalComingSoon"
          >
            <!-- <feather-icon icon="CheckSquareIcon" />  -->
            Preview
          </a>
          <!-- isCustomer && -->
          <!-- Bổ sung quyền Booking hộ cho Sales 09/08/2022 -->

          <a
            @click="handBooking"
            v-if="status != 10 && step == 'booking' && status == 61"
            class="btn custom_btn_quote pl-2 pr-2 mr-1"
          >
            <!-- <feather-icon icon="CheckSquareIcon" />  -->
            Confirm
          </a>
          <a
            @click="handSubmit"
            v-if="
              (step == 'booking' &&
                status != 10 &&
                request_quotation.status_id == null) ||
              copy
            "
            class="btn custom_btn_quote pl-2 pr-2 mr-1"
          >
            <!-- <feather-icon icon="CheckSquareIcon" />  -->
            Submit
          </a>
          <!-- $bvModal.show('request-an-update-msg') -->
          <a
            @click="handUpdatePricingCheckData"
            v-if="
              request_quotation.accept_edit == 1 &&
              status != 10 &&
              step == 'booking' &&
              !isCustomer &&
              [9, 10, 11].includes(status) &&
              !readonly
            "
            class="btn custom_btn_quote pl-2 pr-2 mr-1"
          >
            <!-- <feather-icon icon="CheckSquareIcon" />  -->
            Update Pricing
          </a>

          <!--step shipment-->
          <!-- 22/5/2024 Thêm điều kiện với LCL (3) isPOL_VN là false nghĩa là nước ngoài thì sẽ được tạo fast mà không cần xác nhận booking note   --> 
          <a
            @click="$bvModal.show('new-shipment-fast')"
            :class="
              ![5, 6, 61, 16, 10, 12].includes(status) &&
              request_quotation.shipment_on_fast == null
                ? 'btn-info'
                : 'btn-secondary'
            "
            v-if="
              request_quotation.accept_edit == 1 &&
              step == 'booking' &&
              !isCustomer &&
              ((['1', '2', '4', '5', '6'].includes(
                request_quotation.service_type.toString()
              ) &&
                ![5, 6, 61, 16].includes(status)) ||
                (request_quotation.service_type.toString() == '3' &&
                  (this.request_quotation.isPOL_VN
                    ? ![5, 6, 61, 16, 17].includes(status)
                    : ![5, 6, 61, 16].includes(status))))
            "
            class="btn custom_btn_quote pl-2 pr-2 mr-1"
          >
            <feather-icon icon="TruckIcon" /> New Shipment on FAST
          </a>

          <!-- {{ request_quotation.has_d2d_trucking || request_quotation.has_van_trucking }} -->
          <a
            @click="() => showModal()"
            :class="
              ![5, 6, 61, 16, 10, 12].includes(status) &&
              request_quotation.shipment_on_tms == null
                ? 'btn-info'
                : 'btn-secondary'
            "
            v-if="
              request_quotation.accept_edit == 1 &&
              step == 'booking' &&
              !isCustomer &&
              ((['1', '2', '4', '5', '6', 1, 2, 4, 5, 6].includes(
                request_quotation.service_type
              ) &&
                (status == 63 ||
                  status == 8 ||
                  status == 7 ||
                  status == 9 ||
                  status == 17)) ||
                (!['5', '6', '61', '16'].includes(status.toString()) &&
                  request_quotation.service_type.toString() == '3' &&
                  (request_quotation.has_d2d_trucking ||
                    request_quotation.has_van_trucking)) ||
                (!['5', '6', '61', '16'].includes(status.toString()) &&
                  request_quotation.service_type.toString() != '3'))
            "
            class="btn custom_btn_quote pl-2 pr-2 mr-1"
          >
            <feather-icon icon="TruckIcon" /> New Shipment on TMS
          </a>
        </div>
      </div>
    </div>
    <b-modal
      id="request-an-update"
      title="Request an update"
      no-close-on-backdrop
      @ok="handRequestAnUpdate"
    >
      <b-card-text>
        <validation-observer ref="reqanupdateRules">
          <validation-provider
            name="message"
            #default="{ errors }"
            rules="required"
          >
            <b-form-textarea
              :class="errors.length > 0 ? 'is-invalid' : null"
              rows="5"
              v-model="message"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </validation-observer>
      </b-card-text>
    </b-modal>
    <b-modal
      :id="`request-an-update-msg-${step}`"
      no-close-on-backdrop
      title="Request an update"
      @ok="handRequestAnUpdate"
    >
      <b-card-text>
        <validation-observer ref="reqanupdateRules">
          <validation-provider
            name="Message"
            #default="{ errors }"
            rules="required"
          >
            <b-form-textarea
              :class="errors.length > 0 ? 'is-invalid' : null"
              rows="5"
              v-model="message"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </validation-observer>
      </b-card-text>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      id="cancel-booking_1"
      title="Cancel Booking"
      @ok="handCancelBooking"
    >
      <b-card-text>
        <validation-observer ref="cancelRules">
          <validation-provider
            name="Reason"
            #default="{ errors }"
            rules="required"
          >
            <b-form-textarea
              :class="errors.length > 0 ? 'is-invalid' : null"
              rows="5"
              v-model="cancel_reason"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
          -->
        </validation-observer>
      </b-card-text>
    </b-modal>
    <b-modal
      id="accept-booking"
      title="Accept Booking"
      v-if="booking != null"
      @ok="handAcceptBooking"
      ok-title="Send"
    >
      <b-card-text>
        <label>Import Booking (Sea/Air)</label>
        <vue-dropzone
          ref="acceptBookingFile"
          size="lg"
          id="acceptBookingFile"
          :options="dropzoneOptions"
          :useCustomSlot="true"
        >
          <div class="dropzone-custom-content">
            <p>Drag and drop to upload file</p>
            <feather-icon size="3x" class="text-success" icon="UploadIcon" />
          </div>
        </vue-dropzone>
        <b-form-group class="mt-1">
          <label>Notes</label>
          <b-form-textarea rows="4" v-model="notesUpFile"></b-form-textarea>
        </b-form-group>
      </b-card-text>
    </b-modal>
    <b-modal
      id="edit-booking"
      title="Resend Booking"
      size="lg"
      v-if="booking != null"
      @ok="editBooking"
    >
      <b-card-text>
        <label>Import Booking (Sea/Air)</label>
        <vue-dropzone
          ref="editBookingFile"
          id="editBookingFile"
          :options="dropzoneOptions"
          :useCustomSlot="true"
        >
          <div class="dropzone-custom-content">
            <p>Drag and drop to upload file</p>
            <feather-icon size="3x" class="text-success" icon="UploadIcon" />
          </div>
        </vue-dropzone>

        <b-form-group class="mt-1">
          <label>Notes</label>
          <b-form-textarea rows="4" v-model="notesUpFile"></b-form-textarea>
        </b-form-group>
      </b-card-text>
    </b-modal>
    <b-modal
      id="new-shipment-fast"
      title="New Shipment On FAST"
      hide-footer
      size="xl"
      v-if="booking != null"
    >
      <b-card-text>
        <new-shipment-on-fast
          :request_quotation="request_quotation"
          :booking="booking"
          :readonly="![5, 6, 61, 16, 10, 12].includes(status) ? false : true"
          :shippingDetail="shippingDetail"
          @NewShipmentToFast="
            $bvModal.hide('new-shipment-fast');
            $emit('NewShipmentToFast', $event);
          "
        />
      </b-card-text>
    </b-modal>
    <b-modal
      v-model="ModalComingSoon"
      no-close-on-backdrop
      @close="ModalComingSoon = false"
      dialog-class="new-dialog-modal-reject"
      header-class="new-modal-reject"
      title=""
      hide-footer
    >
      <template #modal-title>
        <div class="header-title-reject">COMING SOON</div>
      </template>
      <div class="custom_text_coming">THIS FEATURE IS COMING SOON</div>
    </b-modal>
    <b-modal
      id="new-shipment-tms"
      :title="'New Shipment On TMS [' + this.booking.id + ']'"
      hide-footer
      v-if="
        step == 'booking' &&
        !isCustomer &&
        request_quotation != null &&
        booking != null
      "
      @hide="$bvModal.hide('new-shipment-tms')"
      size="xl"
    >
      <b-card-text>
        <!-- NewShipmentOnTms -->
        <new-shipment-on-tms
          :request_quotation="request_quotation"
          :booking="booking"
          :readonly="
            (booking && booking.status_id == 63) || booking.status_id == 17
              ? false
              : true
          "
          @NewShipmentToTMS="
            $bvModal.hide('new-shipment-tms');
            $emit('NewShipmentToTMS', $event);
          "
        />
      </b-card-text>
    </b-modal>

    <b-modal
      id="new-shipment-tms-v2"
      v-model="newShipmentTMS"
      class="new-shipment-tms-v2"
      content-class="new-shipment-tms-v2-content"
      header-class="new-shipment-tms-v2-header"
      hide-footer
      v-if="
        step == 'booking' &&
        !isCustomer &&
        request_quotation != null &&
        booking != null
      "
      @hide="$bvModal.hide('new-shipment-tms')"
      size="xl"
    >
      <b-card-text>
        <!-- NewShipmentOnTmsV2 -->
        <NewShipmentOnTmsV2
          :request_quotation="request_quotation"
          :booking="booking"
          :readonly="
            (booking && booking.status_id == 63) || booking.status_id == 17
              ? false
              : true
          "
          @NewShipmentToTMS="
            $bvModal.hide('new-shipment-tms');
            $emit('NewShipmentToTMS', $event);
          "
          @UpdateShipmentDetail="$emit('UpdateShipmentDetail', $event)"
        />
      </b-card-text>
    </b-modal>
    <b-modal
      body-class="p-0"
      size="xl"
      id="modal-print-wr1-debit"
      :title="'View Debit Note PDF'"
      :hide-footer="true"
    >
      <vue-pdf-app
        v-if="pdfDebit"
        :pdf="pdfDebit"
        style="height: 85vh"
        :fileName="'DebitNote'"
        pageScale="70"
      ></vue-pdf-app>
    </b-modal>
    <!-- <b-modal
      id="new-booking-quotation"
      title="Additional Information"
      hide-footer
      size="xl"
    >
      <FormNewBooking :request_quotation="request_quotation" />
    </b-modal> -->
  </div>
</template>
<style>
.is-invalid .select2-selection--single {
  border: 1px solid #ea5455;
}

.is-invalid .select2-selection--single::before {
  content: "";
  position: absolute;
  right: 14px;
  top: 0;
  bottom: 0;
  width: 14px;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ea5455' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23ea5455' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
}

.btn-cancel-custom {
  background-color: gray;
  color: white !important;
  border-radius: 10px;
}

.red {
  color: red;
}

.custom_btn_quote {
  background-color: #2b938c;
  color: white !important;
  border-radius: 10px;
}

.vue-dropzone > .dz-preview .dz-details {
  background-color: #2b938c;
  border-radius: 15px;
}

.table-print {
  border-collapse: collapse !important;
  width: 100%;
  border: 1px solid #333 !important;
}

.table-print td {
  text-align: left;
}

.table-print th {
  text-align: center;
}

.table-print td,
.table-print th {
  border-bottom: 1px solid #333 !important;
  border-right: 1px solid #333 !important;
  padding: 4px 6px;
}

.table-print th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #2b938c;
  color: white;
}

.modal-footer .btn {
  width: auto !important;
}
</style>
<script>
import {
  BAvatar,
  BForm,
  BFormTextarea,
  BImg,
  BDropdown,
  BDropdownItem,
  BButton,
  BFormInput,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormDatepicker,
  BRow,
  BCol,
  BTable,
  BCard,
  BCardText,
} from "bootstrap-vue";
import Select2 from "v-select2-component";
import useJwt from "@/auth/jwt/useJwt";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState, mapActions } from "vuex";

import { $ctx } from "@themeConfig";
import VueHtml2pdf from "vue-html2pdf";
import Vue from "vue";
import moment from "moment";
import PrintQuotation from "./PrintQuotation.vue";
import PrintPricing from "./PrintPricing.vue";

import NewShipmentOnFast from "./NewShipmentOnFast.vue";
import NewShipmentOnTms from "./NewShipmentOnTms.vue";
import NewShipmentOnTmsV2 from "../../wr1/V2/NewTms/NewShipmentOnTms.vue";

import NProgress from "nprogress";
import FormNewBooking from "./FormNewBooking.vue";
import { default as VNnum2words } from "vn-num2words";
import { default as Dollar2words } from "dollars-to-words";
import VuePdfApp from "vue-pdf-app";

const default_costs = [
  {
    stt: 1,
    id: "freight",
    name: "Freight",
    detail: [
      {
        id: Math.floor(Math.random() * Math.pow(10, 5)),
        payableAcc: null,
        payableAcc_fast_id: "",
        payableAcc_tms_id: "",
        fee_type: null,
        fee_type_name: "Phí nâng cont",
        fee_type_dbt: 0,
        fee_type_kbck: 0,
        fee_type_freight: 0,
        fee_type_logistics: 0,
        fee_type_trucking: 0,
        fee_type_code: "1",
        is_tms: "1",
        companyItems: 4,
        unit: null,
        unit_tms_id: null,
        unit_fast_id: "CBM",
        unit_name: "CBM CUBIC METRIC",
        unit_price: 0,
        qty: 1,
        currency: "USD",
        notes: "",
        checked: true,
        vat: 0,
        payment: "DEBT",
        tms_id: "",
        fast_id: "",
        fast_approve_id: "",
        truckId: null,
      },
    ],
  },

  {
    stt: 2,
    id: "local_pol",
    name: "Local charges at POL",
    detail: [
      {
        id: Math.floor(Math.random() * Math.pow(10, 5)),
        payableAcc: null,
        payableAcc_fast_id: "",
        payableAcc_tms_id: "",
        fee_type: null,
        fee_type_name: "Phí nâng cont",
        fee_type_dbt: 0,
        fee_type_kbck: 0,
        fee_type_freight: 0,
        fee_type_logistics: 0,
        fee_type_trucking: 0,
        fee_type_code: "1",
        is_tms: "1",
        companyItems: 4,
        unit: null,
        unit_tms_id: null,
        unit_fast_id: "CBM",
        unit_name: "CBM CUBIC METRIC",
        unit_price: 0,
        qty: 1,
        currency: "USD",
        notes: "",
        checked: true,
        vat: 0,
        payment: "DEBT",
        tms_id: "",
        fast_id: "",
        fast_approve_id: "",
        truckId: null,
      },
    ],
  },
  {
    stt: 3,
    id: "pol",
    name: "Service at POL",
    detail: [
      {
        id: Math.floor(Math.random() * Math.pow(10, 5)),
        payableAcc: null,
        payableAcc_fast_id: "",
        payableAcc_tms_id: "",
        fee_type: null,
        fee_type_name: "Phí nâng cont",
        fee_type_dbt: 0,
        fee_type_kbck: 0,
        fee_type_freight: 0,
        fee_type_logistics: 0,
        fee_type_trucking: 0,
        fee_type_code: "1",
        is_tms: "1",
        companyItems: 4,
        unit: "",
        unit_tms_id: null,
        unit_fast_id: "CBM",
        unit_name: "CBM CUBIC METRIC",
        unit_price: 0,
        qty: 1,
        currency: "USD",
        notes: "",
        checked: true,
        vat: 0,
        payment: "DEBT",
        tms_id: "",
        fast_id: "",
        fast_approve_id: "",
        truckId: null,
      },
    ],
  },
  {
    stt: 4,
    id: "local_pod",
    name: "Local charges at POD",
    detail: [
      {
        id: Math.floor(Math.random() * Math.pow(10, 5)),
        payableAcc: null,
        payableAcc_fast_id: "",
        payableAcc_tms_id: "",
        fee_type: null,
        fee_type_name: "Phí nâng cont",
        fee_type_dbt: 0,
        fee_type_kbck: 0,
        fee_type_freight: 0,
        fee_type_logistics: 0,
        fee_type_trucking: 0,
        fee_type_code: "1",
        is_tms: "1",
        companyItems: 4,
        unit: "",
        unit_tms_id: null,
        unit_fast_id: "CBM",
        unit_name: "CBM CUBIC METRIC",
        unit_price: 0,
        qty: 1,
        currency: "USD",
        notes: "",
        checked: true,
        vat: 0,
        payment: "DEBT",
        tms_id: "",
        fast_id: "",
        fast_approve_id: "",
        truckId: null,
      },
    ],
  },
  {
    stt: 5,
    id: "pod",
    name: "Service at POD",
    detail: [
      {
        id: Math.floor(Math.random() * Math.pow(10, 5)),
        payableAcc: null,
        payableAcc_fast_id: "",
        payableAcc_tms_id: "",
        fee_type: null,
        fee_type_name: "Phí nâng cont",
        fee_type_dbt: 0,
        fee_type_kbck: 0,
        fee_type_freight: 0,
        fee_type_logistics: 0,
        fee_type_trucking: 0,
        fee_type_code: "1",
        is_tms: "1",
        companyItems: 4,
        unit: "",
        unit_tms_id: null,
        unit_fast_id: "CBM",
        unit_name: "CBM CUBIC METRIC",
        unit_price: 0,
        qty: 1,
        currency: "USD",
        notes: "",
        checked: true,
        vat: 0,
        payment: "DEBT",
        tms_id: "",
        fast_id: "",
        fast_approve_id: "",
        truckId: null,
      },
    ],
  },
];

const default_com = [
  {
    id: "commission",
    name: "Commission",
    detail: [
      {
        id: Math.floor(Math.random() * Math.pow(10, 5)),
        payableAcc: null,
        payableAcc_fast_id: "",
        payableAcc_tms_id: "",
        fee_type: 234,
        fee_type_name: "COMMISSION TO CUSTOMER",
        fee_type_dbt: 0,
        fee_type_kbck: 0,
        fee_type_freight: 0,
        fee_type_logistics: 0,
        fee_type_trucking: 0,
        fee_type_code: "B_COMMISSIONCUSTOMER",
        is_tms: "0",
        companyItems: 4,
        unit: "CBM",
        unit_tms_id: null,
        unit_fast_id: "CBM",
        unit_name: "CBM CUBIC METRIC",
        unit_price: 0,
        qty: 1,
        currency: "USD",
        notes: "",
        checked: true,
        vat: 0,
        payment: "DEBT",
        tms_id: "",
        fast_id: "",
        fast_approve_id: "",
        truckId: null,
      },
    ],
  },
];
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  props: {
    readonly: { default: false, type: Boolean },
    view_quotation: { default: null },
    request_quotation: { default: null },
    isCustomer: { default: null },
    booking: { default: null },
    step: { default: null },
    serviceType: { default: null },
    create: { default: false },
    proc_code: { default: false },
    status: { default: false },
    shipmentDetail: {
      default: null,
    },
    copy: {
      default: false,
    },
  },
  components: {
    VuePdfApp,
    FormNewBooking,
    VuePerfectScrollbar,
    PrintPricing,
    NewShipmentOnTms,
    NewShipmentOnFast,
    BAvatar,
    BForm,
    PrintQuotation,
    BImg,
    VueHtml2pdf,
    BDropdown,
    BDropdownItem,
    BButton,
    BFormTextarea,
    ValidationProvider,
    BCardText,
    ValidationObserver,
    BFormInput,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BRow,
    BCol,
    BTable,
    BCard,
    BCardText,
    Select2,
    vueDropzone: vue2Dropzone,
    FeatherIcon,
    NewShipmentOnTmsV2,
  },
  data() {
    return {
      selectCheckbox: [{ id: "Uno", value: 1, status: false }],
      newShipmentTMS: false,
      tempNext: null,
      tempBooking: null,
      hasChange: false,
      showUpdate: false,
      cost: false,
      userData: JSON.parse(localStorage.getItem("userData")),
      ModalComingSoon: false,
      reloadDate: 1,
      valueDateFrom: null,
      valueDateTo: null,
      iconAdd: require("@/assets/images/icons/add.png"),
      remove: require("@/assets/images/icons/remove.png"),
      pdfDebit: null,
      VNnum2words,
      Dollar2words,
      showTimePanel: false,
      renderTotal: 1,
      cancel_reason: "",
      arrayNew: [],
      companyID: 0,
      notesUpFile: "",
      showPdf: false,
      isDraft: false,
      valueProgress: 0,
      appLogoImage: require("@/assets/images/logo/logo.svg"),
      currencies: [
        { id: "VND", text: "VNĐ" },
        { id: "USD", text: "USD" },
      ],
      payments: [
        { id: "DEBT", text: "DEBT" },
        { id: "BEHALF", text: "BEHALF" },
      ],
      quotation: {
        shipping_line: null,
        valid_from: new Date(),
        costs: null,
        quotationNotes:
          "The price does not include VAT, insurance,...\n- We hope that above rates and conditions shall meet your requirement.\n- Required export license & provide full docs for customs clearance.\n- Meanwhile, please feel free to contact us at if you have any questions.",
      },
      tempQuotation:
        JSON.parse(JSON.stringify(this.view_quotation)) ||
        JSON.parse(JSON.stringify(this.booking)),

      default_costs: default_costs,
      costs: null,
      tempCosts: null,
      commission: default_com,
      chats: null,
      dynamicService: false,
      service_types: [],
      regions: [],
      message: null,
      dropzoneOptions: {
        url: $ctx.API_URL + "uploadFile",
        addRemoveLinks: true,
        acceptedFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.type,
        maxFilesize: this.$Utils.CONSTANTS.TYPE_UPLOAD.size,
        maxFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.max,
        headers: { apiKey: localStorage.getItem("accessToken") },
      },
      dataDefaultsAdd: null,
    };
  },
  watch: {
    // showAddMore: {
    //     deep: true,
    //     handler(n, o) {
    //         this.value.cargo_details = n;
    //     },
    // },
    costs: {
      deep: true,
      handler(n, o) {
        if (o == null) {
          this.tempNext = JSON.stringify(n[0].detail);
        }
        if (JSON.stringify(n[0].detail) != this.tempNext) {
          this.hasChange = true;
        }
      },
    },

    serviceType(val) {},
    valueProgress(val) {
      if (val == 100) this.$loading.hide();
    },
    readonly(n, o) {
      if (this.showUpdate) {
        this.readonly = false;
      }
    },
  },
  computed: {
    ...mapState("masterData", [
      "companyItems",
      "companyItemsName",
      "cont_types",
      "fee_types",
      "shipping_lines",
      "locations",
      "ports",
      "truckList",
    ]),

    orderedCosts: function () {
      return _.orderBy(this.costs, "stt");
    },

    feeTypesFilter() {
      return this.fee_types.filter(
        (e) =>
          e.code.indexOf("B_COMMISSIONCUSTOMER") != -1 ||
          e.code.indexOf("B_REFUND") != -1 ||
          e.code.indexOf("S_") != -1 ||
          e.tms_id > 0
      );
    },
    readonlyEdit() {
      return this.request_quotation && this.request_quotation?.status_id == 8;
    },
    exchangeRate: function () {
      return this.$store.getters["masterData/exchangeRate"];
    },
    unit_types() {
      return this.cont_types;
    },
    company_list() {
      return this.companyItems;
    },
    shippingDetail() {
      return this.$store.state.masterData.shippingDetails;
    },
  },
  created() {
    //this.request_quotation.pol_port

    // });
    this.loadChart();
    if (this.tempQuotation && this.tempQuotation.costs !== undefined) {
      this.tempBooking = this.tempQuotation.costs;
    } else {
    }
  },
  async mounted() {
    this.costs = null;
    this.$root.$on("bv::modal::shown", (bvEvent, modalId) => {
      document.getElementsByClassName("modal-content").forEach(function (v) {
        v.removeAttribute("tabindex");
      });
    });
    this.request_quotation?.shipping_line
      ? (this.request_quotation.carriers_name =
          this.shipping_lines.filter(
            (e) => e.id == this.request_quotation.shipping_line
          ).length > 0
            ? this.shipping_lines.filter(
                (e) => e.id == this.request_quotation.shipping_line
              )[0].name
            : "")
      : "";
    // this.costs = null;
    if (
      (this.request_quotation != null &&
        this.request_quotation?.costs_van_cont == null) ||
      !this.request_quotation.quotation
    ) {
      this.quotation.id = this.request_quotation.id;

      this.costs = await this.arrayDynamicService(this.request_quotation);

      this.dataDefaultsAdd = this.costs[0].detail[0];

      this.commission.forEach((c) => {
        c.detail.forEach((i) => {
          i.payableAcc = this.request_quotation.company_id
            ? this.request_quotation.company_id
            : i.payableAcc;

          i.payableAcc_fast_id =
            this.companyItemsName.find(
              (e) => e.id == this.request_quotation.company_id
            )?.fast_id || "";

          i.payableAcc_tms_id =
            this.companyItemsName.find(
              (e) => e.id == this.request_quotation.company_id
            )?.tms_id || "";

          i.unit_name = this.unit_types.find((e) => e.id == i.unit)?.text || "";

          i.unit_tms_id =
            this.unit_types.find((e) => e.id == i.unit)?.tms_id || null;

          i.unit_fast_id =
            this.unit_types.find((e) => e.id == i.unit)?.fast_id || "";

          i.fee_type_name =
            this.fee_types.find((e) => e.id == i.fee_type)?.text || "";
          i.vat = this.fee_types.find((e) => e.id == i.fee_type)?.vat || 0;
          i.currency =
            this.fee_types.find((e) => e.id == i.fee_type)?.currency || "VND";
          i.fee_type_dbt =
            this.fee_types.find((e) => e.id == i.fee_type)?.dbt || 0;

          i.fee_type_kbck =
            this.fee_types.find((e) => e.id == i.fee_type)?.kbck || 0;
          i.fee_type_freight =
            this.fee_types.find((e) => e.id == i.fee_type)?.freight || 0;

          i.fee_type_code =
            this.fee_types.find((e) => e.id == i.fee_type)?.code || 0;
          i.fee_type_logistics =
            this.fee_types.find((e) => e.id == i.fee_type)?.logistics || 0;
          i.fee_type_trucking =
            this.fee_types.find((e) => e.id == i.fee_type)?.trucking || 0;

          i.is_tms =
            this.fee_types.find((e) => e.id == i.fee_type)?.is_tms || 0;
          i.fee_type_tms_id =
            this.fee_types.find((e) => e.id == i.fee_type)?.tms_id || null;
        });
      });
    } else if (this.request_quotation?.costs_van_cont != null) {
      this.costs = this.request_quotation.costs_van_cont.costs;
      this.dataDefaultsAdd = this.costs[0].detail[0];
      this.quotation.valid_from = this.request_quotation.costs_van_cont
        .valid_from
        ? this.request_quotation.costs_van_cont.valid_from
        : new Date();
      this.commission.forEach((c) => {
        c.detail.forEach((i) => {
          i.payableAcc = this.request_quotation.company_id
            ? this.request_quotation.company_id
            : i.payableAcc;

          i.payableAcc_fast_id =
            this.companyItemsName.find(
              (e) => e.id == this.request_quotation.company_id
            )?.fast_id || "";

          i.payableAcc_tms_id =
            this.companyItemsName.find(
              (e) => e.id == this.request_quotation.company_id
            )?.tms_id || "";

          i.unit_name = this.unit_types.find((e) => e.id == i.unit)?.text || "";

          i.unit_tms_id =
            this.unit_types.find((e) => e.id == i.unit)?.tms_id || null;

          i.unit_fast_id =
            this.unit_types.find((e) => e.id == i.unit)?.fast_id || "";

          i.fee_type_name =
            this.fee_types.find((e) => e.id == i.fee_type)?.text || "";
          i.vat = this.fee_types.find((e) => e.id == i.fee_type)?.vat || 0;
          i.currency =
            this.fee_types.find((e) => e.id == i.fee_type)?.currency || "VND";
          i.fee_type_dbt =
            this.fee_types.find((e) => e.id == i.fee_type)?.dbt || 0;
          i.fee_type_kbck =
            this.fee_types.find((e) => e.id == i.fee_type)?.kbck || 0;
          i.fee_type_freight =
            this.fee_types.find((e) => e.id == i.fee_type)?.freight || 0;
          i.fee_type_code =
            this.fee_types.find((e) => e.id == i.fee_type)?.code || 0;
          i.fee_type_logistics =
            this.fee_types.find((e) => e.id == i.fee_type)?.logistics || 0;
          i.fee_type_trucking =
            this.fee_types.find((e) => e.id == i.fee_type)?.trucking || 0;

          i.is_tms =
            this.fee_types.find((e) => e.id == i.fee_type)?.is_tms || 0;
          i.fee_type_tms_id =
            this.fee_types.find((e) => e.id == i.fee_type)?.tms_id || null;
        });
      });
    }
    if (
      this.view_quotation != null &&
      this.view_quotation?.costs != null &&
      (this.step == "quotation" ||
        this.step == "view-quotation-booking" ||
        this.step == "view-created-quotation" ||
        this.step == "booking")
    ) {
      this.quotation = this.view_quotation;
      this.costs = this.view_quotation.costs;
      this.quotation.valid_from = this.view_quotation.valid_from
        ? this.view_quotation.valid_from
        : new Date();

      // this.costs = await this.arrayDynamicService(this.view_quotation);
    }

    if (this.booking != null && this.step == "booking") {
      if (typeof this.booking != "string") {
        this.costs = this.booking.costs
          ? this.booking.costs
          : await this.arrayDynamicService(this.request_quotation);
      } else {
        this.costs = JSON.parse(this.booking).costs
          ? JSON.parse(this.booking).costs
          : await this.arrayDynamicService(this.request_quotation);
      }

      this.dataDefaultsAdd = this.costs[0].detail[0];

      this.quotation.cut_off = this.booking.cut_off;
      this.quotation.fred = this.booking.fred;
      this.quotation.transit_time = this.booking.transit_time;
      this.quotation.valid_to = this.booking.valid_to;
      this.quotation.via = this.booking.via;
      this.quotation.shipping_line = this.booking.shipping_line;
      this.quotation.notes = this.booking.quotationNotes;
      this.quotation.incurredCost = this.FN(this.booking.incurredCost);
      this.commission = this.booking.commission || default_com;
      this.costs.forEach((c) => {
        c.detail.forEach((i) => {
          i.payableAcc =
            typeof this.booking == "string"
              ? this.request_quotation.company_id
              : i.payableAcc != null
              ? i.payableAcc
              : this.serviceType?.company_id ||
                this.request_quotation.company_id;
          i.payableAcc_fast_id =
            this.companyItemsName.find((e) => e.id == i.payableAcc)?.fast_id ||
            "";
          i.payableAcc_tms_id =
            this.companyItemsName.find((e) => e.id == i.payableAcc)?.tms_id ||
            "";
          i.unit_name = this.unit_types.find((e) => e.id == i.unit)?.text || "";
          i.unit_tms_id =
            this.unit_types.find((e) => e.id == i.unit)?.tms_id || null;

          i.unit_fast_id =
            this.unit_types.find((e) => e.id == i.unit)?.fast_id || "";
          i.fee_type_name =
            this.fee_types.find((e) => e.id == i.fee_type)?.text || "";

          i.fee_type_dbt =
            this.fee_types.find((e) => e.id == i.fee_type)?.dbt || 0;
          i.fee_type_kbck =
            this.fee_types.find((e) => e.id == i.fee_type)?.kbck || 0;
          i.fee_type_freight =
            this.fee_types.find((e) => e.id == i.fee_type)?.freight || 0;
          i.fee_type_code =
            this.fee_types.find((e) => e.id == i.fee_type)?.code || 0;
          i.fee_type_logistics =
            this.fee_types.find((e) => e.id == i.fee_type)?.logistics || 0;
          i.fee_type_trucking =
            this.fee_types.find((e) => e.id == i.fee_type)?.trucking || 0;

          i.is_tms =
            this.fee_types.find((e) => e.id == i.fee_type)?.is_tms || 0;
          i.fee_type_tms_id =
            this.fee_types.find((e) => e.id == i.fee_type)?.tms_id || null;
        });
      });
      this.commission.forEach((c) => {
        c.detail.forEach((i) => {
          i.payableAcc =
            i.payableAcc != null
              ? i.payableAcc
              : this.request_quotation.company_id;

          i.payableAcc_fast_id =
            this.companyItemsName.find((e) => e.id == i.payableAcc)?.fast_id ||
            "";

          i.payableAcc_tms_id =
            this.companyItemsName.find((e) => e.id == i.payableAcc)?.tms_id ||
            "";

          i.unit_name = this.unit_types.find((e) => e.id == i.unit)?.text || "";

          i.unit_tms_id =
            this.unit_types.find((e) => e.id == i.unit)?.tms_id || null;

          i.unit_fast_id =
            this.unit_types.find((e) => e.id == i.unit)?.fast_id || "";

          i.fee_type_name =
            this.fee_types.find((e) => e.id == i.fee_type)?.text || "";

          i.fee_type_dbt =
            this.fee_types.find((e) => e.id == i.fee_type)?.dbt || 0;
          i.fee_type_kbck =
            this.fee_types.find((e) => e.id == i.fee_type)?.kbck || 0;
          i.fee_type_freight =
            this.fee_types.find((e) => e.id == i.fee_type)?.freight || 0;
          i.fee_type_code =
            this.fee_types.find((e) => e.id == i.fee_type)?.code || 0;
          i.fee_type_logistics =
            this.fee_types.find((e) => e.id == i.fee_type)?.logistics || 0;
          i.fee_type_trucking =
            this.fee_types.find((e) => e.id == i.fee_type)?.trucking || 0;

          i.is_tms =
            this.fee_types.find((e) => e.id == i.fee_type)?.is_tms || 0;
          i.fee_type_tms_id =
            this.fee_types.find((e) => e.id == i.fee_type)?.tms_id || null;
        });
      });
    }
    if (
      this.request_quotation != null ||
      this.booking != null ||
      quotation != null
    ) {
      let format = "";
      if (typeof this.booking === "string") {
        format = JSON.parse(this.booking);
      } else {
        format = this.booking || this.quotation;
      }

      const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        return `${day < 10 ? "0" + day : day}/${
          month < 10 ? "0" + month : month
        }/${year}`;
      };

      this.valueDateFrom = formatDate(format.valid_from);
      this.valueDateTo = formatDate(format.valid_to);
      this.reloadDate++;
    }

    if (
      this.serviceType != null &&
      this.serviceType.service_type !== null &&
      typeof this.booking != "object"
    ) {
      this.$forceUpdate();
      this.costs = await this.arrayDynamicService(this.serviceType);
      this.dataDefaultsAdd = this.costs[0].detail[0];
      let costs = JSON.parse(JSON.stringify(default_com));
      costs.forEach((c) => {
        c.detail.forEach((i) => {
          i.payableAcc =
            i.payableAcc != null ? i.payableAcc : this.serviceType.company_id;
          i.payableAcc_fast_id =
            this.companyItemsName.find((e) => e.id == i.payableAcc)?.fast_id ||
            "";
          i.payableAcc_tms_id =
            this.companyItemsName.find((e) => e.id == i.payableAcc)?.tms_id ||
            "";
          i.unit_name = this.unit_types.find((e) => e.id == i.unit)?.text || "";
          i.unit_tms_id =
            this.unit_types.find((e) => e.id == i.unit)?.tms_id || null;

          i.unit_fast_id =
            this.unit_types.find((e) => e.id == i.unit)?.fast_id || "";
          i.fee_type_name =
            this.fee_types.find((e) => e.id == i.fee_type)?.text || "";
          i.vat = this.fee_types.find((e) => e.id == i.fee_type)?.vat || 0;
          i.currency =
            this.fee_types.find((e) => e.id == i.fee_type)?.currency || "VND";
          i.fee_type_dbt =
            this.fee_types.find((e) => e.id == i.fee_type)?.dbt || 0;
          i.fee_type_kbck =
            this.fee_types.find((e) => e.id == i.fee_type)?.kbck || 0;
          i.fee_type_freight =
            this.fee_types.find((e) => e.id == i.fee_type)?.freight || 0;
          i.fee_type_code =
            this.fee_types.find((e) => e.id == i.fee_type)?.code || 0;
          i.fee_type_logistics =
            this.fee_types.find((e) => e.id == i.fee_type)?.logistics || 0;
          i.fee_type_trucking =
            this.fee_types.find((e) => e.id == i.fee_type)?.trucking || 0;

          i.is_tms =
            this.fee_types.find((e) => e.id == i.fee_type)?.is_tms || 0;
          i.fee_type_tms_id =
            this.fee_types.find((e) => e.id == i.fee_type)?.tms_id || null;
        });
      });

      this.commission = costs;
    }

    if (
      !this.readonly &&
      this.view_quotation &&
      this.view_quotation.costs == null &&
      this.step != "booking" &&
      this.request_quotation != null
    ) {
      const dataFormat = await this.arrayDynamicService(this.request_quotation);
    }
    this.tempCosts =
      this.costs == null ? null : JSON.parse(JSON.stringify(this.costs));
  },

  methods: {
    async handleUpdateCancel() {
      this.booking.accept_files = [];
      var validate = await this.$refs.quotationRules
        .validate()
        .then((success) => {
          this.$loading.hide();

          return success;
        });
      if (!validate) {
        this.$bvModal.hide("edit-booking");
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        this.$loading.hide();

        return;
      }
      let t = 0;
      let totalVatVnd = 0;
      let totalVatUsd = 0;
      let vatVND = 0;
      let vatUSD = 0;
      let totalVND = 0;
      let totalUSD = 0;

      this.currencies.forEach((e) => {
        t += this.getTotal(e.id);

        if (e.id == "USD") {
          totalVatUsd += this.getTotalGrandTotal(e.id);
          vatUSD += this.getTotalVAT(e.id);
          totalUSD += this.getTotal(e.id);
        } else {
          totalVatVnd += this.getTotalGrandTotal(e.id);
          vatVND += this.getTotalVAT(e.id);
          totalVND += this.getTotal(e.id);
        }
      });

      const cost_total = {
        exchange_rate: this.exchangeRate,
        total: totalUSD * this.exchangeRate + totalVND,
        vat: vatUSD * this.exchangeRate + vatVND,
        total_vat: totalVatUsd * this.exchangeRate + totalVatVnd,
      };
      // if (t == 0 || Number.isNaN(t)) {
      //   this.$toast({
      //     component: ToastificationContent,
      //     props: {
      //       title: "Total = 0, please enter at least one fee!",
      //       icon: "AlertTriangleIcon",
      //       variant: "warning",
      //     },
      //   });
      //   this.$loading.hide();

      //   return;
      // }

      this.quotation.costs = this.costs;
      this.quotation.cost_total = cost_total;

      this.quotation.commission = this.commission;

      this.quotation.tempQuotation = !this.isDraft
        ? this.quotation.tempQuotation
        : null;
      this.quotation.createdBy = this.userData.username;
      this.quotation.createDate = moment(new Date()).format("DD/MM/YYYY");
      useJwt
        .put("wr1?objectType=CancelBooking", {
          ...this.quotation,
          id: this.request_quotation.id,
          cancel_reason: this.cancel_reason,
          cost: 1,
        })
        .then((response) => {
          (this.showUpdate = false),
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Booking Cancelled success!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          this.$bvModal.hide("cancel-booking_1");

          this.$emit("CancelBookingEvent");
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Booking Cancel error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.$loading.hide();
        });
    },
    showModalComingSoon() {
      this.ModalComingSoon = true;
    },
    isLCLEXPORT() {
      const fast = ["LCL_EXPORT"];
      if (this.proc_code) {
        return fast.some((item1) => this.proc_code.includes(item1));
      } else return false;
    },
    isFAST() {
      const fast = [
        "LCL_EXPORT",
        "LCL_IMPORT",
        "LCL_D2D_EXPORT",
        "LCL_D2D_IMPORT",
      ];
      if (this.proc_code) {
        return fast.some((item1) => this.proc_code.includes(item1));
      } else return false;
    },
    isTMS() {
      const tms = [
        "CONT_EXPORT",
        "CONT_IMPORT",
        "CONT_TRANSFER_PORT",
        "CONT_TRANSFER_WAREHOUSE",
        "TRUCK_EXPORT",
        "TRUCK_IMPORT",
        "LCL_D2D_EXPORT",
        "LCL_D2D_IMPORT",
        "TRUCK_TRANSFER_WAREHOUSE",
      ];
      if (this.proc_code) {
        return tms.some((item1) => this?.proc_code.includes(item1));
      } else return false;
    },

    ...mapActions("masterData", ["fetchCompany"]),
    FN: function (value) {
      try {
        return (value + "")
          .replace(/[^0-9]/g, "")
          .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
      } catch (err) {
        return value;
      }
    },
    FnUSD: function (value) {
      try {
        return (value + "")
          .replace(/[^0-9 || \\.]/g, "")
          .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      } catch (err) {
        return value;
      }
    },
    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    toggleTimeRangePanel() {
      this.showTimeRangePanel = !this.showTimeRangePanel;
    },
    handleCloseChange() {
      this.$refs.datePicker.popupVisible = false;
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    handleRangeClose() {
      this.showTimeRangePanel = false;
    },
    getValuePayment(i, number) {
      if (number == 1) {
        this.i = "DEBT";
      }
      if (number == 2) {
        this.i = "BEHALF";
      }
    },
    loadChart() {
      if (this.quotation != null && this.quotation.id != null) {
        useJwt
          .get("wr1?objectType=Chats", {
            params: { search: { id: this.quotation.id } },
          })
          .then((response) => {
            this.chats =
              response.data.result == null
                ? null
                : response.data.result.reverse();
          });
      }
    },
    async handSubmit(e) {
      this.$emit("checkRequestBooking");

      var validate = await this.$refs.quotationRules
        .validate()
        .then((success) => {
          this.$loading.hide();

          return success;
        });
      if (!validate) {
        this.$bvModal.hide("edit-booking");
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        this.$loading.hide();

        return;
      }
      let t = 0;
      let totalVatVnd = 0;
      let totalVatUsd = 0;
      let vatVND = 0;
      let vatUSD = 0;
      let totalVND = 0;
      let totalUSD = 0;
      this.currencies.forEach((e) => {
        t += this.getTotal(e.id);
      });
      this.currencies.forEach((e) => {
        t += this.getTotal(e.id);

        if (e.id == "USD") {
          totalVatUsd += this.getTotalGrandTotal(e.id);
          vatUSD += this.getTotalVAT(e.id);
          totalUSD += this.getTotal(e.id);
        } else {
          totalVatVnd += this.getTotalGrandTotal(e.id);
          vatVND += this.getTotalVAT(e.id);
          totalVND += this.getTotal(e.id);
        }
      });
      // if (t == 0 || Number.isNaN(t)) {
      //   this.$toast({
      //     component: ToastificationContent,
      //     props: {
      //       title: "Total = 0, please enter at least one fee!",
      //       icon: "AlertTriangleIcon",
      //       variant: "warning",
      //     },
      //   });
      //   return;
      // }
      const cost_total = {
        exchange_rate: this.exchangeRate,
        total: totalUSD * this.exchangeRate + totalVND,
        vat: vatUSD * this.exchangeRate + vatVND,
        total_vat: totalVatUsd * this.exchangeRate + totalVatVnd,
      };
      var fileAll = JSON.parse(JSON.stringify(this.request_quotation.files));

      this.request_quotation.files = [];

      this.$loading.show();
      this.$emit("ok-clicked");
      this.$emit("ok-clicked-van");
      this.quotation.costs = this.costs;
      this.quotation.cost_total = cost_total;
      this.quotation.tempQuotation = !this.isDraft
        ? this.quotation.tempQuotation
        : null;
      this.quotation.commission = this.commission;
      this.quotation.createdBy = this.userData.username;
      this.quotation.createDate = moment(new Date()).format("DD/MM/YYYY");

       // check showAddMore nếu type == 3
       if (
        this.request_quotation?.service_type.toString() ==
        "3"
      ) {
        // check không có type  showAddMore
        if (
          ! this.request_quotation.request_quotation?.showAddMore
        ) {
          
         
        }
      }

      useJwt
        .post("wr1?objectType=RequestWr1Booking", {
          request_quotation: this.request_quotation,
          quotation: {
            ...this.quotation,
            createdBy: this.userData.username,
            createDate: moment(new Date()).format("DD/MM/YYYY"),
          },
        })
        .then((response) => {
          if (fileAll.length > 0 && response.data.meta.bookingId) {
            for (let index = 0; index < fileAll.length; index++) {
              const element = fileAll[index];

              this.$store.dispatch("attachFile/upFile", {
                bookingId: response.data.meta.bookingId,
                isRequestFile: "1",
                ...element,
              });
            }
          }

          if (response.data.result == "1") {
            this.request_quotation.id = response.data.meta.bookingId;
            this.valueModal = false;
            // call add file
            // this.loadBookingNote();
            //TODO them api upfile

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Booking Request Successfully",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          }
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Booking Request Error",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => this.$loading.hide());
    },
    arrayDynamicService(type) {
      let costs_type = JSON.parse(JSON.stringify(default_costs));
      costs_type.forEach((c) => {
        c.detail.forEach((i) => {
          i.payableAcc = i.payableAcc != null ? i.payableAcc : type.company_id;
          i.payableAcc_fast_id =
            this.companyItemsName.find(
              (e) => e.id == i.payableAcc || e.id == type.company_id
            )?.fast_id || "";
          i.payableAcc_tms_id =
            this.companyItemsName.find(
              (e) => e.id == i.payableAcc || e.id == type.company_id
            )?.tms_id || "";
          i.unit_name = this.unit_types.find((e) => e.id == i.unit)?.text || "";
          i.unit_tms_id =
            this.unit_types.find((e) => e.id == i.unit)?.tms_id || null;

          i.unit_fast_id =
            this.unit_types.find((e) => e.id == i.unit)?.fast_id || "";
          i.fee_type_name =
            this.fee_types.find((e) => e.id == i.fee_type)?.text || "";
          i.vat = this.fee_types.find((e) => e.id == i.fee_type)?.vat || 0;
          i.currency =
            this.fee_types.find((e) => e.id == i.fee_type)?.currency || "VND";
          i.fee_type_dbt =
            this.fee_types.find((e) => e.id == i.fee_type)?.dbt || 0;
          i.fee_type_kbck =
            this.fee_types.find((e) => e.id == i.fee_type)?.kbck || 0;
          i.fee_type_freight =
            this.fee_types.find((e) => e.id == i.fee_type)?.freight || 0;
          i.fee_type_code =
            this.fee_types.find((e) => e.id == i.fee_type)?.code || 0;
          i.fee_type_logistics =
            this.fee_types.find((e) => e.id == i.fee_type)?.logistics || 0;
          i.fee_type_trucking =
            this.fee_types.find((e) => e.id == i.fee_type)?.trucking || 0;

          i.is_tms =
            this.fee_types.find((e) => e.id == i.fee_type)?.is_tms || 0;
          i.fee_type_tms_id =
            this.fee_types.find((e) => e.id == i.fee_type)?.tms_id || null;
        });
      });
      if (type != null) {
        if (
          (type != null && type.service_type == 1) ||
          type.service_type == 2 ||
          type.service_type == 3
        ) {
          if (!type.has_container_trucking && !type.has_van_trucking) {
            costs_type.splice(1, 1);
            costs_type.splice(3, 1);
          }
        }
        if (type.service_type == 4 && type.customs_other_service_type == null) {
          costs_type.splice(1, 1);
          costs_type.splice(3, 1);
        }
        if (type.service_type == 5 || type.service_type == 6) {
          if (type.has_customs == null) {
            costs_type.splice(1, 1);
            costs_type.splice(3, 1);
          }
        }
        this.dynamicService = true;
        return costs_type;
      }
    },
    onProgress(val) {
      this.valueProgress = val;
    },
    generateDataReport() {
      // 1.1 1.2 1.3 => 5	6 61

      // 5 6 61 16 17
      var POL = "";
      var POD = "";
      var ETA = "";
      var ETD = "";
      var swCbm = "";
      var Shipper = "";
      var Consignee = "";
      var vessel = "";
      var conSeal = "";
      if (["5", "6", "61"].includes(this.request_quotation.status_id)) {
        POL = this.request_quotation.pol_port
          ? this.ports.find((e) => e.id == this.request_quotation.pol_port)
              ?.name || ""
          : "";
        POD = this.request_quotation.pod_port
          ? this.ports.find((e) => e.id == this.request_quotation.pod_port)
              ?.name || ""
          : "";
        ETA = this.request_quotation.eta;
        ETD = this.request_quotation.etd;
        swCbm =
          this.request_quotation?.showAddMore?.[0]?.gross_weight_total +
          this.request_quotation?.showAddMore?.[0]?.volume_total;
      } else {
        // WR1021023000010
        if (
          this.shipmentDetail?.shipper_name ||
          this.shipmentDetail?.consignee_name ||
          this.shipmentDetail?.vessel ||
          this.shipmentDetail?.pol_port ||
          this.shipmentDetail?.pod_port ||
          this.shipmentDetail?.eta ||
          this.shipmentDetail?.etd
        ) {
          // shipment
          Shipper = this.shipmentDetail?.shipper_name || "";
          Consignee = this.shipmentDetail?.consignee_name || "";
          vessel = this.shipmentDetail?.vessel;
          POL = this.shipmentDetail?.pol_port
            ? this.ports.find((e) => e.id == this.shipmentDetail.pol_port)
                ?.name || ""
            : "";
          POD = this.shipmentDetail?.pod_port
            ? this.ports.find((e) => e.id == this.shipmentDetail.pod_port)
                ?.name || ""
            : "";
          ETA = this.shipmentDetail?.eta;
          ETD = this.shipmentDetail?.etd;
          swCbm =
            this.shipmentDetail?.showAddMore?.[0]?.gross_weight_total +
            this.shipmentDetail?.showAddMore?.[0]?.volume_total;
        } else {
          POL = this.request_quotation.pol_port
            ? this.ports.find((e) => e.id == this.request_quotation.pol_port)
                ?.name || ""
            : "";
          POD = this.request_quotation.pod_port
            ? this.ports.find((e) => e.id == this.request_quotation.pod_port)
                ?.name || ""
            : "";
          ETA = this.request_quotation.eta;
          ETD = this.request_quotation.etd;
          swCbm =
            this.request_quotation?.showAddMore?.[0]?.gross_weight_total +
            this.request_quotation?.showAddMore?.[0]?.volume_total;
        }
        //NOTE: cont mới có
        if (this.shipmentDetail?.valueContainer) {
          conSeal =
            (this.shipmentDetail?.valueContainer?.[0]?.ContainerLine?.[0]
              ?.containerLine3?.[0]?.container_no
              ? this.shipmentDetail?.valueContainer?.[0]?.ContainerLine?.[0]
                  ?.containerLine3?.[0]?.container_no
              : "") +
            " " +
            (this.shipmentDetail?.valueContainer?.[0]?.ContainerLine?.[0]
              ?.containerLine3?.[0]?.seal_no
              ? this.shipmentDetail?.valueContainer?.[0]?.ContainerLine?.[0]
                  ?.containerLine3?.[0]?.seal_no
              : "");
        }
      }

      return new Promise((resolveInner) => {
        var ARRAY_DATA = [];

        this.costs.map((cost) => {
          cost.detail.map((i) => {
            return ARRAY_DATA.push({
              PAYABLE_ACC: this.companyItems.filter(
                (k) => k.id == i.payableAcc
              )[0]
                ? this.companyItems.filter((k) => k.id == i.payableAcc)[0]
                    .Acronym
                : "",
              DESCRIPTION:
                this.fee_types.filter((k) => k.id == i.fee_type)[0]?.text || "",
              UNIT: this.unit_types.filter((k) => k.id == i.unit)[0]
                ? this.unit_types.filter((k) => k.id == i.unit)[0].text
                : "",
              UNIT_PRICE: this.formatDollar(i.unit_price),
              QUANTITY: i.qty,
              AMOUNT:
                i.currency == "USD"
                  ? this.FnUSD(
                      (
                        i.qty * (i.unit_price + "").replace(/,/g, "") +
                        i.qty *
                          (i.unit_price + "").replace(/,/g, "") *
                          (i.vat ? i.vat / 100 : "0")
                      ).toFixed(2)
                    )
                  : this.FN(
                      i.qty *
                        (i.unit_price + "")
                          .replace(/\./g, "")
                          .replace(/,/g, "") +
                        i.qty *
                          (i.unit_price + "")
                            .replace(/\./g, "")
                            .replace(/,/g, "") *
                          (i.vat ? i.vat / 100 : "0")
                    ) + `(VAT: ${i.vat}%)`,
              EX_RATE_VND:
                i.currency == "USD"
                  ? this.FN(
                      (
                        (i.qty * (i.unit_price + "").replace(/,/g, "") +
                          i.qty *
                            (i.unit_price + "").replace(/,/g, "") *
                            (i.vat ? i.vat / 100 : "0")) *
                        this.exchangeRate
                      ).toFixed(2)
                    )
                  : this.FN(
                      i.qty *
                        (i.unit_price + "")
                          .replace(/\./g, "")
                          .replace(/,/g, "") +
                        i.qty *
                          (i.unit_price + "")
                            .replace(/\./g, "")
                            .replace(/,/g, "") *
                          (i.vat ? i.vat / 100 : "0")
                    ),
              EX_RATE_USD:
                i.currency == "USD"
                  ? this.formatDollar(
                      (
                        i.qty * (i.unit_price + "").replace(/,/g, "") +
                        i.qty *
                          (i.unit_price + "").replace(/,/g, "") *
                          (i.vat ? i.vat / 100 : "0")
                      ).toFixed(2)
                    )
                  : (i.qty *
                      (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") +
                      (i.qty *
                        (i.unit_price + "")
                          .replace(/\./g, "")
                          .replace(/,/g, "") *
                        i.vat) /
                        100) /
                      this.exchangeRate >
                    0
                  ? this.formatDollar(
                      (
                        (i.qty *
                          (i.unit_price + "")
                            .replace(/\./g, "")
                            .replace(/,/g, "") +
                          (i.qty *
                            (i.unit_price + "")
                              .replace(/\./g, "")
                              .replace(/,/g, "") *
                            i.vat) /
                            100) /
                        this.exchangeRate
                      ).toFixed(2)
                    )
                  : 0,
              // FN(
              //   i.qty *
              //     (i.unit_price + "")
              //       .replace(/\./g, "")
              //       .replace(/,/g, "") +
              //     i.qty *
              //       (i.unit_price + "")
              //         .replace(/\./g, "")
              //         .replace(/,/g, "") *
              //       (i.vat ? i.vat / 100 : "0")
              // )
              NOTE: i.notes,
            });
          });
        });
        const dataNew = {
          P_TO_NAME: this.request_quotation.customer_name,
          P_TO_COMPANY: this.request_quotation.customer_company_name,
          P_TO_ADDRESS: this.request_quotation.customer_company_address,
          P_TO_PHONE: this.request_quotation.customer_phone,
          P_TO_EMAIL: this.request_quotation.customer_email,
          P_FROM_SALES: this.request_quotation.sale_name,
          P_FROM_PHONE: this.request_quotation.sale_phone,
          P_FROM_EMAIL: this.request_quotation.sale_email,
          P_FROM_BOOKING_NO: this.request_quotation.id,
          P_FROM_ISSUE_DATE: moment(new Date()).format("DD/MM/YYYY"),
          P_POL: POL,
          P_ETD_ETA: ETA ? ETA : "" + "/" + "" + ETD ? ETD : "" || "",
          P_SHIPPER: Shipper || "",
          P_VESSEL_VOY: vessel,
          P_POD: POD ? POD || "" : "",
          P_BILL_OF_LADING: this.shippingDetail?.HBL || "",
          P_CONSIGNEE: Consignee || "",
          P_GW_CBM: swCbm || "",
          P_CONT_SEAL: conSeal || "",
          P_JSON_DATA: JSON.stringify(ARRAY_DATA).toString(),
          P_SUBTOTAL_VND: this.$Utils.formatMooney(
            this.getSumTotalVND(),
            "en-US"
          ),
          P_SUBTOTAL_USD: this.formatDollar(this.getSumTotalUSD().toFixed(2)),
          P_IN_WORDS_VND:
            VNnum2words(this.getSumTotalVND()).charAt(0).toUpperCase() +
            VNnum2words(this.getSumTotalVND()).slice(1),
          P_IN_WORDS_USD:
            Dollar2words(this.getSumTotalUSD().toFixed(2))
              .charAt(0)
              .toUpperCase() +
            Dollar2words(this.getSumTotalUSD().toFixed(2)).slice(1),
        };
        resolveInner(dataNew);
      });
    },
    getSumTotalVND() {
      var a = 0;

      this.costs.forEach((c) => {
        c.detail.forEach((i) => {
          if (i.checked && i.currency == "VND") {
            a +=
              i.qty * (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") +
              i.qty *
                (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                (i.vat ? i.vat / 100 : "0");
          } else {
            a +=
              (i.qty * (i.unit_price + "").replace(/,/g, "") +
                i.qty *
                  (i.unit_price + "").replace(/,/g, "") *
                  (i.vat ? i.vat / 100 : "0")) *
              this.exchangeRate;
          }
        });
      });

      return a.toFixed(0);
    },
    getTotalVND(currency) {
      var t = 0;
      if (currency == "VND") {
        this.costs.forEach((c) => {
          c.detail.forEach((i) => {
            if (i.checked && i.currency == currency) {
              t +=
                i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") +
                i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                  (i.vat ? i.vat / 100 : "0");
            }
          });
        });
      } else {
        this.costs.forEach((c) => {
          c.detail.forEach((i) => {
            if (i.checked && i.currency == currency) {
              t +=
                (i.qty * (i.unit_price + "").replace(/,/g, "") +
                  i.qty *
                    (i.unit_price + "").replace(/,/g, "") *
                    (i.vat ? i.vat / 100 : "0")) *
                this.exchangeRate;
            }
          });
        });
      }
      return t;
    },
    async generateReport() {
      if (this.step == "booking") {
        try {
          this.$loading.show();

          const dataPDF = await this.generateDataReport();
          useJwt
            .post(
              "jasper",
              {
                j_type: "pdf",
                j_report: "DEBIT_NOTE",
                j_scr: "default",
                j_name: "DEBIT_NOTE",
                ...dataPDF,
              },
              { responseType: "arraybuffer" }
            )
            .then((response) => {
              this.pdfDebit = response.data;

              this.$bvModal.show("modal-print-wr1-debit");
              this.$loading.hide();
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Lỗi lấy dữ liệu, vui lòng thử lại!",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
              this.$loading.hide();
            });
        } catch (error) {
          console.log(error);
        }
      } else {
        this.showPdf = true;
        try {
          await this.$loading.show();
          this.request_quotation.quotationNotes = this.quotation.quotationNotes;

          const doc = await this.$refs.html2Pdf.generatePdf();
        } catch (error) {
          await this.$loading.hide();
        }
      }
    },
    getTotal(currency) {
      if (this.costs != null) {
        var t = 0;
        this.costs.forEach((c) => {
          c.detail.forEach((i) => {
            if (i.checked && i.currency == currency) {
              if (currency == "USD") {
                t += i.qty * (i.unit_price + "").replace(/,/g, "");
              } else {
                t +=
                  i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "");
              }
            }
          });
        });
        return t;
      }
    },
    getTotalGrandTotal(currency) {
      var t = 0;
      this.costs?.forEach((c) => {
        c.detail.forEach((i) => {
          if (i.checked && i.currency == currency) {
            if (currency == "USD") {
              t +=
                i.qty * (i.unit_price + "").replace(/,/g, "") +
                i.qty *
                  (i.unit_price + "").replace(/,/g, "") *
                  (i.vat ? i.vat / 100 : "");
            } else {
              t +=
                i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") +
                i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                  (i.vat ? i.vat / 100 : "");
            }
          }
        });
      });
      return t;
    },
    getSumTotalUSD() {
      var a = 0;

      this.costs.forEach((c) => {
        c.detail.forEach((i) => {
          if (i.checked && i.currency == "VND") {
            a +=
              (i.qty *
                (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") +
                (i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                  i.vat) /
                  100) /
              this.exchangeRate;
          } else {
            a +=
              i.qty * (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") +
              i.qty *
                (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                (i.vat ? i.vat / 100 : "0");
          }
        });
      });

      return a;
    },
    getTotalVAT(currency) {
      var t = 0;
      this.costs.forEach((c) => {
        c.detail.forEach((i) => {
          if (i.checked && i.currency == currency) {
            if (currency == "USD") {
              t +=
                i.qty *
                (i.unit_price + "").replace(/,/g, "") *
                (i.vat ? i.vat / 100 : "");
            } else {
              t +=
                i.qty *
                (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                (i.vat ? i.vat / 100 : "");
            }
          }
        });
      });
      return t;
    },
    async handAcceptBooking(ev) {
      this.$loading.show();
      ev.preventDefault();
      this.booking.accept_files = [];
      for (
        var i = 0;
        i < this.$refs.acceptBookingFile.getAcceptedFiles().length;
        i++
      ) {
        var file = JSON.parse(
          this.$refs.acceptBookingFile.getAcceptedFiles()[i].xhr.response
        ).result;
        file.size = `${
          this.$refs.acceptBookingFile.getAcceptedFiles()[i].size
        }`;
        file.date = moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
        file.notes = this.notesUpFile;
        file.uuid =
          this.$refs.acceptBookingFile.getAcceptedFiles()[i].upload.uuid;

        file.fullName = this.userData.fullName;
        file.username = this.userData.username;
        file.isRequestFile = "0";
        file.bookingId = this.booking.id;
        // this.booking.accept_files.push(file);
        this.booking.createdBy = this.userData.fullName;
        this.booking.createDate = moment(new Date()).format("DD/MM/YYYY");
        this.$store.dispatch("attachFile/upFile", file);
        // this.booking.accept_files.push(file);
      }
      useJwt
        .put("wr1?objectType=AcceptBooking", this.booking)
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Accepted Booking success!",
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });

          if (this.notesUpFile) {
            useJwt.put("wr1?objectType=SendChat", {
              id: this.booking.id,
              message: this.notesUpFile,
              date: new Date(),
              role: "wr1",
              fullName: this.userData.fullName,
            });
          }

          this.$bvModal.hide("accept-booking");
          this.$emit("AcceptBookingEvent", []);
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Accept Booking error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.$loading.hide();
        });
    },
    uploadSuccess: function (file, response) {
      response.result.isRequestFile = "0";
      response.result.bookingId = this.booking.id;
      response.result.size = `${file.size}`;
      if (file && response.message == "success!") {
        this.$store.dispatch("attachFile/upFile", response.result);
      }
    },
    removeFile(file, error, xhr) {
      const xhrJson = JSON.parse(file.xhr.response);
      const path = xhrJson.result.path;
      const bookingId = this.booking.id;
      this.$store.dispatch("attachFile/deleteFile", { bookingId, path });
    },
    updateBooking() {
      this.booking.createdBy = this.userData.username;
      this.booking.createDate = moment(new Date()).format("DD/MM/YYYY");
      useJwt
        .put("wr1?objectType=AcceptBooking", this.booking)
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Accepted Booking success!",
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
          this.$bvModal.hide("accept-booking");
          this.$emit("AcceptBookingEvent", []);
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Accept Booking error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    showModal: async function () {
      try {
        this.$loading.show();
        // this.$bvModal.show("new-shipment-tms");

        var validate = await this.$refs.quotationRules
          .validate()
          .then((success) => {
            this.$loading.hide();

            return success;
          });
        if (!validate) {
          this.$bvModal.hide("edit-booking");
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("notifyFormError"),
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          this.$loading.hide();

          return;
        }

        let t = 0;
        let totalVatVnd = 0;
        let totalVatUsd = 0;
        let vatVND = 0;
        let vatUSD = 0;
        let totalVND = 0;
        let totalUSD = 0;
        this.currencies.forEach((e) => {
          t += this.getTotal(e.id);
        });
        this.currencies.forEach((e) => {
          t += this.getTotal(e.id);

          if (e.id == "USD") {
            totalVatUsd += this.getTotalGrandTotal(e.id);
            vatUSD += this.getTotalVAT(e.id);
            totalUSD += this.getTotal(e.id);
          } else {
            totalVatVnd += this.getTotalGrandTotal(e.id);
            vatVND += this.getTotalVAT(e.id);
            totalVND += this.getTotal(e.id);
          }
        });

        if (this.request_quotation.shipment_on_tms == null) {
          const cost_total = {
            exchange_rate: this.exchangeRate,
            total: totalUSD * this.exchangeRate + totalVND,
            vat: vatUSD * this.exchangeRate + vatVND,
            total_vat: totalVatUsd * this.exchangeRate + totalVatVnd,
          };
          this.quotation.costs = this.costs;
          this.quotation.cost_total = cost_total;

          this.quotation.commission = this.commission;

          this.quotation.tempQuotation = !this.isDraft
            ? this.quotation.tempQuotation
            : null;
          this.quotation.createdBy = this.userData.username;
          this.quotation.createDate = moment(new Date()).format("DD/MM/YYYY");

          useJwt
            .put("wr1?objectType=EditBooking", this.quotation)
            .then((response) => {})
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Resend Booking success error!",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
            })
            .finally(() => this.$loading.hide());
        }

        this.newShipmentTMS = true;
      } catch (error) {
        console.log(error);
      }
    },
    async handUpdatePricing(ev) {
      ev.preventDefault();
      var tempBooking = {};

      let t = 0;
      let totalVatVnd = 0;
      let totalVatUsd = 0;
      let vatVND = 0;
      let vatUSD = 0;
      let totalVND = 0;
      let totalUSD = 0;

      this.currencies.forEach((e) => {
        t += this.getTotal(e.id);

        if (e.id == "USD") {
          totalVatUsd += this.getTotalGrandTotal(e.id);
          vatUSD += this.getTotalVAT(e.id);
          totalUSD += this.getTotal(e.id);
        } else {
          totalVatVnd += this.getTotalGrandTotal(e.id);
          vatVND += this.getTotalVAT(e.id);
          totalVND += this.getTotal(e.id);
        }
      });

      const cost_total = {
        exchange_rate: this.exchangeRate,
        total: totalUSD * this.exchangeRate + totalVND,
        vat: vatUSD * this.exchangeRate + vatVND,
        total_vat: totalVatUsd * this.exchangeRate + totalVatVnd,
      };

      tempBooking = this.quotation;
      tempBooking.commission = this.commission;
      tempBooking.costs = this.costs;
      tempBooking.cost_total = cost_total;
      (tempBooking.id = this.request_quotation.id),
        (tempBooking.createdBy = this.userData.username);
      tempBooking.customer_id = this.request_quotation.customer_id;
      tempBooking.createDate = new Date();
      tempBooking.tempQuotation = !this.isDraft
        ? this.booking.tempQuotation
        : null;

      if ([9, 10].includes(this.status)) {
        if ([9, 10].includes(this.status)) {
          if (
            (this.request_quotation.canceled_date == null &&
              this.status == 10) ||
            (this.request_quotation.completed_date == null &&
              this.status == 9) ||
            this.request_quotation.locked == 0
          ) {
            tempBooking.update_unpaid = 1;
          } else {
            if (this.request_quotation.canceled_date != null) {
              var dateCancel = this.request_quotation.canceled_date.split("/");
              if (
                (this.dhm(
                  new Date() -
                    new Date(+dateCancel[2], dateCancel[1] - 1, +dateCancel[0])
                ) < 31 &&
                  this.status == 10) ||
                this.request_quotation.locked == 0
              ) {
                tempBooking.update_unpaid = 1;
              }
            } else {
              var dateCom = this.request_quotation.completed_date.split("/");
              if (
                this.dhm(
                  new Date() -
                    new Date(+dateCom[2], dateCom[1] - 1, +dateCom[0])
                ) < 31 &&
                this.status == 9
              ) {
                tempBooking.update_unpaid = 1;
              }
            }
          }
        }
      }

      this.$loading.hide();
      useJwt
        .put("wr1?objectType=UpdateBookingInfo", tempBooking)
        .then((response) => {
          if (response.data.result == 1) {
            this.$emit("RequestAnUpdateEvent");
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Update success!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Update error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => this.$loading.hide());
    },
    dhm(ms) {
      const days = Math.abs(Math.floor(ms / (24 * 60 * 60 * 1000)));
      return days;
    },
    async handBooking(ev) {
      ev.preventDefault();

      var validate = await this.$refs.quotationRules
        .validate()
        .then((success) => {
          this.$loading.hide();

          return success;
        });
      if (!validate) {
        this.$bvModal.hide("edit-booking");
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        this.$loading.hide();

        return;
      }

      this.booking.createdBy = this.userData.username;
      this.booking.createDate = moment(new Date()).format("DD/MM/YYYY");
      useJwt
        .put("wr1?objectType=CustomerBooking", this.booking)
        .then((response) => {
          this.$emit("UpdateShipmentDetail", null);
          this.$emit("CustomerBookingEvent");
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Booking success!",
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Booking error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    async handCancelBooking(bvModalEvt) {
      bvModalEvt.preventDefault();
      var validate = await this.$refs.cancelRules.validate().then((success) => {
        return success;
      });
      if (!validate) {
        this.$loading.hide();

        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      if (this.cost == true) {
        this.$bvModal.hide("cancel-booking_1");
        this.showUpdate = true;
        this.readonly = false;
      } else {
        this.$loading.show();
        useJwt
          .put("wr1?objectType=CancelBooking", {
            id: this.request_quotation.id,
            cancel_reason: this.cancel_reason,
          })
          .then((response) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Booking Cancelled success!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
            this.$bvModal.hide("cancel-booking_1");

            this.$emit("CancelBookingEvent");
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Booking Cancel error!",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => {
            this.$loading.hide();
          });
      }
    },
    handIsDraft() {
      this.isDraft = !this.isDraft;
      if (this.isDraft) {
        if (this.step == "quotation") {
          this.quotation = this.view_quotation.tempQuotation;
          this.costs = this.view_quotation.tempQuotation.costs;
        } else {
          this.quotation = this.booking.tempQuotation;
          this.costs = this.booking.tempQuotation.costs;
        }
      } else {
        if (this.step == "quotation") {
          this.quotation = this.view_quotation;
          this.costs = this.view_quotation.costs;
        } else {
          this.quotation = this.booking;
          this.costs = this.booking.costs;
        }
      }
    },

    async handSaveDraft() {
      let t = 0;
      let totalVatVnd = 0;
      let totalVatUsd = 0;
      let vatVND = 0;
      let vatUSD = 0;
      let totalVND = 0;
      let totalUSD = 0;

      this.currencies.forEach((e) => {
        t += this.getTotal(e.id);

        if (e.id == "USD") {
          totalVatUsd += this.getTotalGrandTotal(e.id);
          vatUSD += this.getTotalVAT(e.id);
          totalUSD += this.getTotal(e.id);
        } else {
          totalVatVnd += this.getTotalGrandTotal(e.id);
          vatVND += this.getTotalVAT(e.id);
          totalVND += this.getTotal(e.id);
        }
      });

      const cost_total = {
        exchange_rate: this.exchangeRate,
        total: totalUSD * this.exchangeRate + totalVND,
        vat: vatUSD * this.exchangeRate + vatVND,
        total_vat: totalVatUsd * this.exchangeRate + totalVatVnd,
      };

      // if (t == 0 || Number.isNaN(t)) {
      //   this.$toast({
      //     component: ToastificationContent,
      //     props: {
      //       title: "Total = 0, please enter at least one fee!",
      //       icon: "AlertTriangleIcon",
      //       variant: "warning",
      //     },
      //   });
      //   return;
      // }

      this.$loading.show();

      this.tempQuotation == null ? (this.tempQuotation = {}) : "";

      this.tempQuotation.id = this.quotation.id;
      this.tempQuotation.costs = this.tempCosts;
      this.tempQuotation.tempQuotation = this.quotation;
      this.tempQuotation.tempQuotation.costs = this.costs;
      this.tempQuotation.tempQuotation.cost_total = cost_total;
      this.tempQuotation.createdBy = this.userData.username;
      this.tempQuotation.createDate = moment(new Date()).format("DD/MM/YYYY");

      if (this.step !== "booking") {
        useJwt
          .put("wr1?objectType=EditQuotation", this.tempQuotation)
          .then((response) => {
            this.$bvModal.hide("modal-approve");
            this.$emit("loadMyQuotation", []);
            this.$emit("RequestAnUpdateEvent");

            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("quotationSaveSuccess"),
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("quotationSaveError"),
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          })

          .finally(() => this.$loading.hide());
      } else {
        this.tempQuotation.commission = this.commission;
        this.tempQuotation.tempQuotation = this.quotation;
        this.tempQuotation.tempQuotation.commission = this.commission;
        this.tempQuotation.tempQuotation.cost_total = this.cost_total;

        this.tempQuotation.createdBy = this.userData.username;
        this.tempQuotation.createDate = moment(new Date()).format("DD/MM/YYYY");

        useJwt
          .put("wr1?objectType=UpdateBookingInfo", this.tempQuotation)
          .then((response) => {
            if (response.data.result == 1) {
              this.$emit("RequestAnUpdateEvent");
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Save success!",
                  icon: "CheckSquareIcon",
                  variant: "primary",
                },
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: response.data.message,
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
            }
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Save error!",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => this.$loading.hide());
      }
    },
    formatDollar(num) {
      return new Intl.NumberFormat("en-US", {
        currency: "USD",
      }).format(Number(num));
    },
    async handSend() {
      var validate = await this.$refs.quotationRules
        .validate()
        .then((success) => {
          return success;
        });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      // let t = 0;
      // this.currencies.forEach((e) => {
      //   t += this.getTotal(e.id);
      // });

      // if (t == 0 || Number.isNaN(t)) {
      //   this.$toast({
      //     component: ToastificationContent,
      //     props: {
      //       title: "Total = 0, please enter at least one fee!",
      //       icon: "AlertTriangleIcon",
      //       variant: "warning",
      //     },
      //   });
      //   return;
      // }
      this.$bvModal.show(`request-an-update-msg-${this.step}`);
    },
    async handUpdatePricingCheckData() {
      var validate = await this.$refs.quotationRules
        .validate()
        .then((success) => {
          return success;
        });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      let t = 0;
      this.currencies.forEach((e) => {
        t += this.getTotal(e.id);
      });
      // if (t == 0 || Number.isNaN(t)) {
      //   this.$toast({
      //     component: ToastificationContent,
      //     props: {
      //       title: "Total = 0, please enter at least one fee!",
      //       icon: "AlertTriangleIcon",
      //       variant: "warning",
      //     },
      //   });
      //   return;
      // }

      this.$bvModal.show(`request-an-update-msg-${this.step}`);
    },
    async handRequestAnUpdate(bvModalEvt) {
      this.$loading.show();

      bvModalEvt.preventDefault();
      var validate = await this.$refs.reqanupdateRules
        .validate()
        .then((success) => {
          return success;
        });
      if (!validate) {
        this.$loading.hide();

        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      if ([9, 10, 11].includes(this.status) && !this.isCustomer) {
        this.$loading.show();

        useJwt
          .put("wr1?objectType=SendChat", {
            id: this.request_quotation.id,
            message: this.message,
            date: new Date(),
            role: this.isCustomer ? "customers" : "wr1",
            fullName: this.userData.fullName,
          })
          .then((response) => {
            if ([9, 10, 11].includes(this.status) && !this.isCustomer) {
              this.loadChart();
              this.$bvModal.hide(`request-an-update-msg-${this.step}`);
              this.$bvModal.hide("request-an-update");
              this.handUpdatePricing(bvModalEvt);
              this.message = "";
              return;
            }
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Send Request An Update error!",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          });
      } else {
        this.$loading.show();
        useJwt
          .put("wr1?objectType=RequestAnUpdate", {
            id: this.request_quotation.id,
            message: this.message,
            date: new Date(),
            type: "customer_update_notes",
            role: this.isCustomer ? "customers" : "wr1",
            fullName: this.userData.fullName,
          })
          .then((response) => {
            if (
              (this.status == 62 && !this.isCustomer) ||
              (this.status == 21 && !this.isCustomer) ||
              (this.status == 4 && !this.isCustomer) ||
              (this.status == 2 && !this.isCustomer) ||
              (this.request_quotation.status_id == 2 && !this.isCustomer) ||
              (this.status == 3 && !this.isCustomer)
            ) {
              this.loadChart();
              this.$bvModal.hide(`request-an-update-msg-${this.step}`);
              this.$bvModal.hide("request-an-update");

              this.message = "";
              this.sendQuotation();

              return;
            }

            // if (this.status == 9 && !this.isCustomer) {
            //   this.loadChart();
            // this.handUpdatePricing(bvModalEvt);
            //   this.$emit("RequestAnUpdateEvent");
            //   this.$bvModal.hide(`request-an-update-msg-${this.step}`);
            //   this.$bvModal.hide("request-an-update");

            //   this.message = "";
            //   return;
            // }
            this.$bvModal.hide(`request-an-update-msg-${this.step}`);
            this.$emit("RequestAnUpdateEvent");

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Send Request An Update success!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
            this.loadChart();

            this.message = "";
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Send Request An Update error!",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => this.$loading.hide());
      }
    },
    acceptQuotation() {
      this.$bvModal.show("new-booking-quotation");

      // this.$loading.show();
      // useJwt
      //   .put("wr1?objectType=AcceptQuotation", {
      //     id: this.request_quotation.id,
      //   })
      //   .then((response) => {
      //     this.$emit("acceptQuotationEvent");
      //     var vm = this;
      //     this.$swal({
      //       icon: "success",
      //       title: "Shipment has been created successfully",
      //       text: "Click here to view booking details!",
      //     }).then(function () {
      //       vm.$router.push({ name: "user-my-booking" });
      //     });
      //   })
      //   .catch((error) => {
      //     this.$toast({
      //       component: ToastificationContent,
      //       props: {
      //         title: "Accept Quotation error!",
      //         icon: "AlertTriangleIcon",
      //         variant: "danger",
      //       },
      //     });
      //   })
      //   .finally(() => this.$loading.hide());
    },
    async sendQuotation() {
      var validate = await this.$refs.quotationRules
        .validate()
        .then((success) => {
          return success;
        });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      let t = 0;
      let totalVatVnd = 0;
      let totalVatUsd = 0;
      let vatVND = 0;
      let vatUSD = 0;
      let totalVND = 0;
      let totalUSD = 0;

      this.currencies.forEach((e) => {
        t += this.getTotal(e.id);

        if (e.id == "USD") {
          totalVatUsd += this.getTotalGrandTotal(e.id);
          vatUSD += this.getTotalVAT(e.id);
          totalUSD += this.getTotal(e.id);
        } else {
          totalVatVnd += this.getTotalGrandTotal(e.id);
          vatVND += this.getTotalVAT(e.id);
          totalVND += this.getTotal(e.id);
        }
      });

      const cost_total = {
        exchange_rate: this.exchangeRate,
        total: totalUSD * this.exchangeRate + totalVND,
        vat: vatUSD * this.exchangeRate + vatVND,
        total_vat: totalVatUsd * this.exchangeRate + totalVatVnd,
      };

      // if (t == 0 || (Number.isNaN(t) && t == "")) {
      //   this.$toast({
      //     component: ToastificationContent,
      //     props: {
      //       title: "Total = 0, please enter at least one fee!",
      //       icon: "AlertTriangleIcon",
      //       variant: "warning",
      //     },
      //   });
      //   return;
      // }
      this.$loading.show();
      this.quotation.costs = this.costs;
      this.quotation.cost_total = cost_total;
      this.quotation.tempQuotation = !this.isDraft
        ? this.quotation.tempQuotation
        : null;
      this.quotation.createdBy = this.userData.username;
      this.quotation.createDate = moment(new Date()).format("DD/MM/YYYY");
      let service =
        this.view_quotation != null
          ? "EditQuotationOfBooking"
          : "CreateQuotationOfBooking";
      useJwt
        .put("wr1?objectType=" + service, this.quotation)
        .then((response) => {
          this.$bvModal.hide("modal-approve");
          this.$emit("loadMyQuotation", []);
          this.$emit("RequestAnUpdateEvent");

          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("quotationSendSuccess"),
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("quotationSendError"),
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })

        .finally(() => this.$loading.hide());
    },
    async editBooking(ev) {
      this.$loading.show();

      ev.preventDefault();
      this.booking.accept_files = [];
      for (
        var i = 0;
        i < this.$refs.editBookingFile.getAcceptedFiles().length;
        i++
      ) {
        var file = JSON.parse(
          this.$refs.editBookingFile.getAcceptedFiles()[i].xhr.response
        ).result;
        file.bookingId = this.quotation.id;
        file.size = this.$refs.editBookingFile.getAcceptedFiles()[i].size;
        file.notes = this.notesUpFile;

        file.isRequestFile =
          this.userData.userType ==
            this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale ||
          this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin
            ? "0"
            : "1";
        this.$store.dispatch("attachFile/upFile", file);
        this.booking.accept_files.push(file);
      }

      var validate = await this.$refs.quotationRules
        .validate()
        .then((success) => {
          this.$loading.hide();

          return success;
        });
      if (!validate) {
        this.$bvModal.hide("edit-booking");
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        this.$loading.hide();

        return;
      }
      let t = 0;
      let totalVatVnd = 0;
      let totalVatUsd = 0;
      let vatVND = 0;
      let vatUSD = 0;
      let totalVND = 0;
      let totalUSD = 0;

      this.currencies.forEach((e) => {
        t += this.getTotal(e.id);

        if (e.id == "USD") {
          totalVatUsd += this.getTotalGrandTotal(e.id);
          vatUSD += this.getTotalVAT(e.id);
          totalUSD += this.getTotal(e.id);
        } else {
          totalVatVnd += this.getTotalGrandTotal(e.id);
          vatVND += this.getTotalVAT(e.id);
          totalVND += this.getTotal(e.id);
        }
      });

      const cost_total = {
        exchange_rate: this.exchangeRate,
        total: totalUSD * this.exchangeRate + totalVND,
        vat: vatUSD * this.exchangeRate + vatVND,
        total_vat: totalVatUsd * this.exchangeRate + totalVatVnd,
      };
      // if (t == 0 || Number.isNaN(t)) {
      //   this.$toast({
      //     component: ToastificationContent,
      //     props: {
      //       title: "Total = 0, please enter at least one fee!",
      //       icon: "AlertTriangleIcon",
      //       variant: "warning",
      //     },
      //   });
      //   this.$loading.hide();

      //   return;
      // }

      this.quotation.costs = this.costs;
      this.quotation.cost_total = cost_total;

      this.quotation.commission = this.commission;

      this.quotation.tempQuotation = !this.isDraft
        ? this.quotation.tempQuotation
        : null;
      this.quotation.createdBy = this.userData.username;
      this.quotation.createDate = moment(new Date()).format("DD/MM/YYYY");

      useJwt
        .put("wr1?objectType=EditBooking", this.quotation)
        .then((response) => {
          this.$emit("EditBookingEvent", []);

          if (this.notesUpFile) {
            useJwt.put("wr1?objectType=SendChat", {
              id: this.booking.id,
              message: this.notesUpFile,
              date: new Date(),
              role: "wr1",
              fullName: this.userData.fullName,
            });
          }

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Resend Booking success!",
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Resend Booking success error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => this.$loading.hide());
    },
    FN: function (value) {
      try {
        return (value + "")
          .replace(/[^0-9]/g, "")
          .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      } catch (err) {
        return value;
      }
    },
    FNVN: function (value) {
      try {
        if (Number(value.replace(/\./g, "").replace(/,/g, ""))) {
          return this.$Utils.formatMooney(
            value.replace(/\./g, "").replace(/,/g, ""),
            "vi-VN"
          );
        }
      } catch (err) {
        return value;
      }
    },
    FNUS: function (value) {
      try {
        if (Number(value.replace(/,/g, ""))) {
          return this.$Utils.formatMooney(value.replace(/,/g, ""), "en-US");
        }
      } catch (err) {
        return value;
      }
    },
    vdropzoneError(file, errorMessage) {
      this.$refs.acceptBookingFile.removeFile(file);
      if (errorMessage.includes("Max filesize: 10MiB")) {
        return this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("uploadSizeErrorFile"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }

      if (errorMessage.includes("You can not upload any more files.")) {
        return this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("uploadLimitErrorFile"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    formatOption(arr) {
      const mapData = arr.map((obj) => {
        obj.text = obj.name;
        obj.id = obj.id;
        return obj;
      });
      return mapData;
    },
    formatOptionCodeName(arr) {
      const mapData = arr.map((obj) => {
        obj.text = this.isCustomer ? obj.name : obj.name + ` (${obj.code})`;
        obj.id = obj.id;
        return obj;
      });
      return mapData;
    },
  },
};
</script>
<style lang="scss">
@import "~@core/scss/base/pages/app-chat.scss";
@import "~@core/scss/base/pages/app-chat-list.scss";

@import "~@core/scss/customs/new-shipment-on-tms.scss";

.custom_cost {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
}

.custom_list_handle_quote {
  display: flex;
  justify-content: end;
  margin-top: 30px;
}

.text-custom_quote {
  color: #2b938c;
  font-size: 2rem;
}

.justify-end {
  justify-content: end;
}

.custom_show_info_quotation {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.text_date {
  font-weight: 500;
  color: #000000;
}

.validity_text {
  font-size: 1.3rem;
  color: #000000;
  font-weight: 500;
}

.quotation_info {
  background-color: #e2f2ef;
  border-radius: 16px;
  width: 400px;
  height: 45px;
  font-size: 1.3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000000;
  font-weight: 500;
}

.custom_view_date {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.custom-bg-quote {
  background-color: #e2f2ef;
  box-shadow: 3px 5px 5px #e2f2ef;
  padding: 1rem;
  border-radius: 10px;
  margin-right: 0;
  margin-left: 0;
  margin-bottom: 2rem;

  & .tb-dropdown .select3-selection .input-selection {
    border: none;
  }

  & .form-control {
    border: none;
  }

  & .select2-container--default .select2-selection--single {
    border: none;
  }
}

.custom_name {
  color: #000000;
  font-size: 1.4rem;
  margin-bottom: 1.5rem;
}

.custom_name_quote {
  color: #000000;
  font-weight: 500;
}

.custom-font {
  font-size: 1.3rem;
  color: #000000;
}

.custom_list_icon {
  padding-top: 2rem;
  display: flex;
  margin-left: 2rem;
  gap: 1rem;
  justify-content: center;
}

.custom_text_coming {
  color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  margin-top: 4rem;
}

.custom_check_quote {
  padding-top: 2rem;
  gap: 1.5rem;
  display: flex;
  color: #000000;
  font-weight: 500;
}

.mybooking-online {
  & .custom_inside_quote {
    & .custom-danger {
      margin-left: -1rem;
    }

    & .max-w-20 {
      max-width: 20%;
    }

    & .select2-selection--single:before {
      background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAAmElEQVQokZ3SwQ3CIBTG8X+7gI6BNzawq3jnoOyBMcEBOooj1BNXV3ACzDOSGEuL8CWEvPeR34lOebcFRkDulD31uQNDF2Nkdz1r4AZsGiDJE9DB2EcvUzB2Ev1TtGCDYDL0aduIJmxKi/67rURn2AysRI+/WBb8Ez0EY8dckQUL6CK2Ci6gpzXsHfmHpaO808q7S/FtjLwAmwh101zduSgAAAAASUVORK5CYII=") !important;
    }

    & .custom_row_quote {
      margin-right: 0;
      margin-left: 0;
    }

    & .tb-dropdown .select3-selection .input-selection {
      border: none;
    }

    & .form-control {
      border: none;
    }

    & .select2-container--default .select2-selection--single {
      border: none;
    }

    & .cursor-pointer {
      cursor: pointer;
    }

    & .custom-checkbox-new {
      /* Ẩn checkbox mặc định */
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      width: 30px;
      height: 30px;
      background-color: white;

      border-radius: 5px;
      outline: none;
      cursor: pointer;
    }

    & .custom-checkbox-new:disabled {
      /* Ẩn checkbox mặc định */
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      width: 30px;
      height: 30px;
      background-color: #f2f2f2;

      border-radius: 5px;
      outline: none;
      cursor: pointer;
    }

    & .custom-checkbox-new:checked {
      background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAMCAYAAACEJVa/AAAACXBIWXMAAAsSAAALEgHS3X78AAAAp0lEQVQokWP4//8/WVhjcm+CxuReAxCbEUSQCjSn9CUwMDDMZ2Bg+MjAwGDARIEBIPCAgYHhAxNUQoEMAy4yMDA4XM8p+sAElbgPpUk2AMQBucQBKjEfl0H4DAAbcj2nCKRgIS6DCBkAcwkDLoOIMQAEUKJYc0rfAgYGhngoF2QojI3TAAxDsBhE0AC4d5ABmtcIGgAGuJK8xuTeBo3JvQIEs8T//wwAEmi0Ch5w3kMAAAAASUVORK5CYII=");
      background-color: white;
      // border: 2px solid #999;
      border-color: white;
      background-repeat: no-repeat;
      background-size: 70%;
      background-position: center;
    }

    & .items-center {
      align-items: center;
    }

    & .flex {
      display: flex;
    }

    & .margin-left {
      margin-left: 0.5rem;
    }

    @media (min-width: 1200px) {
      .border-lg {
      }
    }
  }
}
</style>
